// import { useEffect, useState, useCallback } from "react";
// import {
//   Box,
//   Button,
//   CircularProgress,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   Paper,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   TextField,
//   InputAdornment,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Select,
//   Chip,
//   Divider,
//   IconButton,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Tooltip,
//   ToggleButton,
//   ToggleButtonGroup
// } from "@mui/material";
// import {
//   Search as SearchIcon,
//   Clear as ClearIcon,
//   Download as DownloadIcon,
//   Visibility as VisibilityIcon,
//   Close as CloseIcon,
//   BarChart as BarChartIcon,
//   ShowChart as ShowChartIcon,
//   TrendingUp as TrendingUpIcon,
//   WarningAmber as WarningIcon,
//   Receipt as ReceiptIcon,
//   AccountBalance as AccountBalanceIcon,
//   CompareArrows as CompareIcon
// } from "@mui/icons-material";
// import { format } from "date-fns";
// import { GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

// export default function FinancialComparisonReport() {
//   // Revenue States
//   const [revenueData, setRevenueData] = useState([]);
//   const [filteredRevenueData, setFilteredRevenueData] = useState([]);
//   const [revenueLoading, setRevenueLoading] = useState(true);
  
//   // Arrear States
//   const [arrearsData, setArrearsData] = useState([]);
//   const [filteredArrearsData, setFilteredArrearsData] = useState([]);
//   const [arrearsLoading, setArrearsLoading] = useState(true);
  
//   // Common Filter States
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedPark, setSelectedPark] = useState("all");
//   const [startYear, setStartYear] = useState("all");
//   const [endYear, setEndYear] = useState("all");
//   const [selectedMonth, setSelectedMonth] = useState("all");
//   const [startMonth, setStartMonth] = useState("all");
//   const [endMonth, setEndMonth] = useState("all");
//   const [selectedCurrency, setSelectedCurrency] = useState("all");
//   const [parksList, setParksList] = useState([]);
  
//   // Chart States
//   const [chartType, setChartType] = useState('bar');
//   const [comparisonType, setComparisonType] = useState('comparison');
//   const [showChart, setShowChart] = useState(false);
  
//   // Table Pagination
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
  
//   // Dialog States
//   const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [detailsType, setDetailsType] = useState('revenue');

//   // Years and Months
//   // Generate last 10 years dynamically
// const getLastNYears = (n) => {
//     const currentYear = new Date().getFullYear();
//     const years = ["all"];
//     for (let i = 0; i < n; i++) {
//       years.push((currentYear - i).toString());
//     }
//     return years;
//   };
  
//   // Usage in your component
//   const years = getLastNYears(10);
//   const months = [
//     { value: "all", label: "All Months" },
//     { value: "01", label: "January" },
//     { value: "02", label: "February" },
//     { value: "03", label: "March" },
//     { value: "04", label: "April" },
//     { value: "05", label: "May" },
//     { value: "06", label: "June" },
//     { value: "07", label: "July" },
//     { value: "08", label: "August" },
//     { value: "09", label: "September" },
//     { value: "10", label: "October" },
//     { value: "11", label: "November" },
//     { value: "12", label: "December" }
//   ];

//   // Helper function to normalize currency values
//   const normalizeCurrency = (paymentMode) => {
//     if (!paymentMode) return "unknown";
//     const mode = paymentMode.toLowerCase();
//     if (mode === "usd") return "usd";
//     if (mode === "birr" || mode === "etb") return "birr";
//     return mode;
//   };

//   // Utility Functions
//   const formatNumber = (number) => {
//     let num = 0;
//     if (number !== null && number !== undefined) {
//       if (typeof number === 'string') {
//         const cleaned = number.replace(/[$,]/g, '');
//         num = parseFloat(cleaned);
//       } else {
//         num = parseFloat(number);
//       }
//       if (isNaN(num)) num = 0;
//     }
//     return new Intl.NumberFormat('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(num);
//   };

//   const formatDate = (date) => {
//     if (!date) return "N/A";
//     try {
//       return format(new Date(date), 'dd/MM/yyyy');
//     } catch {
//       return "Invalid Date";
//     }
//   };

//   const formatCurrency = (amount, paymentMode) => {
//     const formatted = formatNumber(amount);
//     const normalizedMode = normalizeCurrency(paymentMode);
    
//     if (normalizedMode === "usd") {
//       return `$${formatted}`;
//     } else {
//       return `${formatted} ETB`;
//     }
//   };

//   const getStatusColor = (overdueDays) => {
//     if (overdueDays >= 90) return "error";
//     if (overdueDays >= 60) return "warning";
//     if (overdueDays >= 30) return "info";
//     if (overdueDays >= 1) return "warning";
//     return "success";
//   };

//   const getStatusText = (overdueDays) => {
//     if (overdueDays >= 90) return "Critical";
//     if (overdueDays >= 60) return "Severe";
//     if (overdueDays >= 30) return "Moderate";
//     if (overdueDays >= 1) return "Mild";
//     return "Current";
//   };

//   // Fetch Revenue Data
//   useEffect(() => {
//     const fetchRevenue = async () => {
//       setRevenueLoading(true);
//       try {
//         const resultData = await GetDataFromApiWithParams(`finances/revenuereport`);
//         let dataArray = [];
        
//         if (resultData && Array.isArray(resultData)) {
//           dataArray = resultData;
//         } else if (resultData && resultData.data && Array.isArray(resultData.data)) {
//           dataArray = resultData.data;
//         } else if (resultData && resultData.results && Array.isArray(resultData.results)) {
//           dataArray = resultData.results;
//         } else if (resultData && resultData.items && Array.isArray(resultData.items)) {
//           dataArray = resultData.items;
//         } else if (resultData && resultData.records && Array.isArray(resultData.records)) {
//           dataArray = resultData.records;
//         } else if (resultData && typeof resultData === 'object') {
//           for (let key in resultData) {
//             if (Array.isArray(resultData[key])) {
//               dataArray = resultData[key];
//               break;
//             }
//           }
//         }
        
//         if (dataArray.length > 0) {
//           const formattedData = dataArray.map((item, index) => {
//             let revenueAmount = 0;
            
//             if (item.payment_amount !== undefined && item.payment_amount !== null) {
//               revenueAmount = parseFloat(item.payment_amount) || 0;
//             } else if (item.amount !== undefined && item.amount !== null) {
//               revenueAmount = parseFloat(item.amount) || 0;
//             } else if (item.revenue !== undefined && item.revenue !== null) {
//               revenueAmount = parseFloat(item.revenue) || 0;
//             }
            
//             let paymentMode = "ETB";
//             if (item.payment_mode) {
//               paymentMode = item.payment_mode;
//             } else if (item.currency) {
//               paymentMode = item.currency;
//             }
            
//             let transactionDate = item.transaction_date || item.date || item.payment_date || item.created_at;
//             let month = item.month;
//             let year = item.year;
            
//             if (transactionDate && !month) {
//               try {
//                 const dateObj = new Date(transactionDate);
//                 if (!isNaN(dateObj.getTime())) {
//                   month = format(dateObj, 'MM');
//                   year = format(dateObj, 'yyyy');
//                 }
//               } catch (e) {}
//             }
            
//             return {
//               id: item.id || item.revenue_id || item.transaction_id || index,
//               transaction_id: item.transaction_id || item.id || `TRX-${index}`,
//               company_name: item.company_name || item.tenant_name || item.customer_name || "N/A",
//               park_name: item.park || item.park_name || item.location || "N/A",
//               payment_mode: paymentMode,
//               amount: revenueAmount,
//               formattedAmount: formatCurrency(revenueAmount, paymentMode),
//               transaction_date: transactionDate,
//               transaction_date_formatted: transactionDate ? formatDate(transactionDate) : "N/A",
//               revenue_type: item.payment_type || item.revenue_type || item.type || item.category || "Rent",
//               payment_status: item.payment_status || item.status || "Completed",
//               invoice_number: item.invoice_number || item.invoice_no || `INV-${index}`,
//               description: item.description || item.notes || `Revenue from ${item.company_name || 'Unknown'}`,
//               month: month || "01",
//               year: year || "2024"
//             };
//           });
          
//           setRevenueData(formattedData);
//           setFilteredRevenueData(formattedData);
          
//           const uniqueParks = [...new Set(formattedData.map(item => item.park_name).filter(Boolean))];
//           setParksList(uniqueParks);
//         }
//       } catch (error) {
//         console.error("Failed to fetch revenue data:", error);
//       } finally {
//         setRevenueLoading(false);
//       }
//     };
    
//     fetchRevenue();
//   }, []);

//   // Fetch Arrear Data
//   useEffect(() => {
//     const fetchArrear = async () => {
//       setArrearsLoading(true);
//       try {
//         const resultData = await GetDataFromApiWithParams(`finances/arrearreport`);
        
//         if (resultData && Array.isArray(resultData)) {
//           const formattedData = resultData.map(item => {
//             const overdueDays = item.overdue_date || 0;
//             const outstandingAmount = parseFloat(item.outstanding) || 0;
//             const paymentMode = item.payment_mode || "ETB";
            
//             // Extract year and month from due_date
//             let year = "2024";
//             let month = "01";
//             if (item.due_date) {
//               try {
//                 const dateObj = new Date(item.due_date);
//                 if (!isNaN(dateObj.getTime())) {
//                   year = format(dateObj, 'yyyy');
//                   month = format(dateObj, 'MM');
//                 }
//               } catch (e) {}
//             }
            
//             return {
//               id: item.agreement_id,
//               agreement_id: item.agreement_id,
//               company_name: item.company_name || "N/A",
//               park_name: item.park || "N/A",
//               payment_mode: paymentMode,
//               outstanding: outstandingAmount,
//               formattedOutstanding: formatCurrency(outstandingAmount, paymentMode),
//               due_date: item.due_date,
//               due_date_formatted: formatDate(item.due_date),
//               overdue_days: overdueDays,
//               status: getStatusText(overdueDays),
//               statusColor: getStatusColor(overdueDays),
//               description: `Arrears for ${item.company_name}`,
//               month: month,
//               year: year
//             };
//           });
          
//           setArrearsData(formattedData);
//           setFilteredArrearsData(formattedData);
          
//           const uniqueParks = [...new Set(formattedData.map(item => item.park_name).filter(Boolean))];
//           setParksList(prev => [...new Set([...prev, ...uniqueParks])]);
//         }
//       } catch (error) {
//         console.error("Failed to fetch arrear data:", error);
//       } finally {
//         setArrearsLoading(false);
//       }
//     };
    
//     fetchArrear();
//   }, []);

//   // Calculate Summary Statistics with Currency Filter
//   const revenueTotalUSD = filteredRevenueData
//     .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//     .reduce((sum, item) => sum + (item.amount || 0), 0);

//   const revenueTotalETB = filteredRevenueData
//     .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//     .reduce((sum, item) => sum + (item.amount || 0), 0);

//   const arrearTotalUSD = filteredArrearsData
//     .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//     .reduce((sum, item) => sum + (item.outstanding || 0), 0);

//   const arrearTotalETB = filteredArrearsData
//     .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//     .reduce((sum, item) => sum + (item.outstanding || 0), 0);

//   // Apply Currency Filter to get filtered amounts for display
//   const getFilteredAmounts = () => {
//     if (selectedCurrency === "usd") {
//       return {
//         revenueTotal: revenueTotalUSD,
//         arrearTotal: arrearTotalUSD,
//         currencySymbol: "$"
//       };
//     } else if (selectedCurrency === "birr") {
//       return {
//         revenueTotal: revenueTotalETB,
//         arrearTotal: arrearTotalETB,
//         currencySymbol: "ETB"
//       };
//     } else {
//       return {
//         revenueTotal: revenueTotalUSD + revenueTotalETB,
//         arrearTotal: arrearTotalUSD + arrearTotalETB,
//         currencySymbol: "$ + ETB"
//       };
//     }
//   };

//   const filteredAmounts = getFilteredAmounts();

//   const revenueStats = {
//     totalTransactions: filteredRevenueData.length,
//     uniqueCompanies: new Set(filteredRevenueData.map(item => item.company_name)).size,
//     totalRevenue: revenueTotalUSD + revenueTotalETB
//   };

//   const arrearStats = {
//     totalCompanies: filteredArrearsData.length,
//     criticalAccounts: filteredArrearsData.filter(item => (item.overdue_days || 0) >= 90).length,
//     totalOverdue: filteredArrearsData.filter(item => (item.overdue_days || 0) > 0).length,
//     totalArrears: arrearTotalUSD + arrearTotalETB
//   };

//   // Filter Data with Year Range and Month Range
//   const applyFilters = useCallback(() => {
//     // Filter Revenue
//     let filteredRevenue = [...revenueData];
//     let filteredArrears = [...arrearsData];
    
//     if (searchTerm) {
//       filteredRevenue = filteredRevenue.filter(item =>
//         item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.transaction_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.park_name?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
      
//       filteredArrears = filteredArrears.filter(item =>
//         item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.agreement_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.park_name?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }
    
//     if (selectedPark !== "all") {
//       filteredRevenue = filteredRevenue.filter(item => item.park_name === selectedPark);
//       filteredArrears = filteredArrears.filter(item => item.park_name === selectedPark);
//     }
    
//     // YEAR RANGE FILTER
//     if (startYear !== "all" || endYear !== "all") {
//       filteredRevenue = filteredRevenue.filter(item => {
//         const itemYear = parseInt(item.year);
//         let startYearNum = startYear !== "all" ? parseInt(startYear) : -Infinity;
//         let endYearNum = endYear !== "all" ? parseInt(endYear) : Infinity;
//         return itemYear >= startYearNum && itemYear <= endYearNum;
//       });
      
//       filteredArrears = filteredArrears.filter(item => {
//         const itemYear = parseInt(item.year);
//         let startYearNum = startYear !== "all" ? parseInt(startYear) : -Infinity;
//         let endYearNum = endYear !== "all" ? parseInt(endYear) : Infinity;
//         return itemYear >= startYearNum && itemYear <= endYearNum;
//       });
//     }
    
//     // Month Range Filter
//     if (startMonth !== "all" || endMonth !== "all") {
//       filteredRevenue = filteredRevenue.filter(item => {
//         const itemMonth = parseInt(item.month);
//         let startMonthNum = startMonth !== "all" ? parseInt(startMonth) : 1;
//         let endMonthNum = endMonth !== "all" ? parseInt(endMonth) : 12;
//         return itemMonth >= startMonthNum && itemMonth <= endMonthNum;
//       });
      
//       filteredArrears = filteredArrears.filter(item => {
//         const itemMonth = parseInt(item.month);
//         let startMonthNum = startMonth !== "all" ? parseInt(startMonth) : 1;
//         let endMonthNum = endMonth !== "all" ? parseInt(endMonth) : 12;
//         return itemMonth >= startMonthNum && itemMonth <= endMonthNum;
//       });
//     }
    
//     // Keep single month filter for backward compatibility
//     if (selectedMonth !== "all" && startMonth === "all" && endMonth === "all") {
//       filteredRevenue = filteredRevenue.filter(item => item.month === selectedMonth);
//       filteredArrears = filteredArrears.filter(item => item.month === selectedMonth);
//     }
    
//     // Currency filter using normalizeCurrency helper
//     if (selectedCurrency !== "all") {
//       filteredRevenue = filteredRevenue.filter(item => 
//         normalizeCurrency(item.payment_mode) === selectedCurrency
//       );
//       filteredArrears = filteredArrears.filter(item => 
//         normalizeCurrency(item.payment_mode) === selectedCurrency
//       );
//     }
    
//     setFilteredRevenueData(filteredRevenue);
//     setFilteredArrearsData(filteredArrears);
//     setPage(0);
//   }, [revenueData, arrearsData, searchTerm, selectedPark, startYear, endYear, selectedMonth, startMonth, endMonth, selectedCurrency]);

//   useEffect(() => {
//     applyFilters();
//   }, [applyFilters]);

//   // Reset Filters
//   const resetFilters = () => {
//     setSearchTerm("");
//     setSelectedPark("all");
//     setStartYear("all");
//     setEndYear("all");
//     setSelectedMonth("all");
//     setStartMonth("all");
//     setEndMonth("all");
//     setSelectedCurrency("all");
//   };

//   // Export to CSV
//   const handleExportCSV = () => {
//     const headers = ['Type', 'ID', 'Company Name', 'Park Name', 'Payment Mode', 'Amount', 'Date', 'Status'];
//     const revenueRows = filteredRevenueData.map(item => [
//       'Revenue',
//       item.transaction_id,
//       item.company_name,
//       item.park_name,
//       item.payment_mode,
//       item.formattedAmount,
//       item.transaction_date_formatted,
//       item.payment_status
//     ]);
    
//     const arrearRows = filteredArrearsData.map(item => [
//       'Arrear',
//       item.agreement_id,
//       item.company_name,
//       item.park_name,
//       item.payment_mode,
//       item.formattedOutstanding,
//       item.due_date_formatted,
//       item.status
//     ]);
    
//     const csvData = [...revenueRows, ...arrearRows];
//     const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `financial_comparison_${format(new Date(), 'yyyyMMdd')}.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   // Pagination Handlers
//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   // Get Combined Table Data
//   const getCombinedTableData = () => {
//     const revenueItems = filteredRevenueData.map(item => ({
//       type: 'revenue',
//       id: item.transaction_id,
//       company_name: item.company_name,
//       park_name: item.park_name,
//       payment_mode: item.payment_mode,
//       amount: item.amount,
//       formattedAmount: item.formattedAmount,
//       date: item.transaction_date_formatted,
//       status: item.payment_status,
//       rawData: item
//     }));
    
//     const arrearItems = filteredArrearsData.map(item => ({
//       type: 'arrear',
//       id: item.agreement_id,
//       company_name: item.company_name,
//       park_name: item.park_name,
//       payment_mode: item.payment_mode,
//       amount: item.outstanding,
//       formattedAmount: item.formattedOutstanding,
//       date: item.due_date_formatted,
//       status: item.status,
//       rawData: item
//     }));
    
//     const combined = [...revenueItems, ...arrearItems];
//     combined.sort((a, b) => b.amount - a.amount);
    
//     const startIndex = page * rowsPerPage;
//     return combined.slice(startIndex, startIndex + rowsPerPage);
//   };

//   const getTotalCombinedCount = () => {
//     return filteredRevenueData.length + filteredArrearsData.length;
//   };

//   // Chart Data Preparation with Currency Filter
//   const getComparisonChartData = (currency = null) => {
//     const parkData = {};
    
//     // Add revenue data with currency filter
//     let revenueToProcess = filteredRevenueData;
//     if (currency) {
//       revenueToProcess = filteredRevenueData.filter(item => 
//         normalizeCurrency(item.payment_mode) === currency
//       );
//     } else if (selectedCurrency !== "all") {
//       revenueToProcess = filteredRevenueData.filter(item => 
//         normalizeCurrency(item.payment_mode) === selectedCurrency
//       );
//     }
    
//     revenueToProcess.forEach(item => {
//       if (!parkData[item.park_name]) {
//         parkData[item.park_name] = {
//           revenueAmount: 0,
//           arrearAmount: 0,
//           netPosition: 0
//         };
//       }
//       parkData[item.park_name].revenueAmount += item.amount || 0;
//     });
    
//     // Add arrears data with currency filter
//     let arrearsToProcess = filteredArrearsData;
//     if (currency) {
//       arrearsToProcess = filteredArrearsData.filter(item => 
//         normalizeCurrency(item.payment_mode) === currency
//       );
//     } else if (selectedCurrency !== "all") {
//       arrearsToProcess = filteredArrearsData.filter(item => 
//         normalizeCurrency(item.payment_mode) === selectedCurrency
//       );
//     }
    
//     arrearsToProcess.forEach(item => {
//       if (!parkData[item.park_name]) {
//         parkData[item.park_name] = {
//           revenueAmount: 0,
//           arrearAmount: 0,
//           netPosition: 0
//         };
//       }
//       parkData[item.park_name].arrearAmount += item.outstanding || 0;
//     });
    
//     // Calculate net position
//     Object.keys(parkData).forEach(park => {
//       parkData[park].netPosition = parkData[park].revenueAmount - parkData[park].arrearAmount;
//     });
    
//     return parkData;
//   };

//   // Comparison Bar Chart Component (Revenue vs Arrears)
//   const ComparisonBarChart = ({ data, title, currencySymbol }) => {
//     const parks = Object.keys(data);
//     const maxRevenue = Math.max(...parks.map(p => data[p].revenueAmount), 0);
//     const maxArrears = Math.max(...parks.map(p => data[p].arrearAmount), 0);
//     const maxValue = Math.max(maxRevenue, maxArrears);
    
//     if (parks.length === 0) {
//       return (
//         <Box sx={{ p: 5, textAlign: 'center' }}>
//           <Typography variant="body2" color="textSecondary">No data available for {title}</Typography>
//         </Box>
//       );
//     }
    
//     return (
//       <Box sx={{ p: 2, overflowX: 'auto' }}>
//         <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
//           {title}
//         </Typography>
        
//         <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 3, minHeight: 400, justifyContent: 'center', flexWrap: 'wrap' }}>
//           {parks.map((park) => {
//             const revenueHeight = maxValue > 0 ? (data[park].revenueAmount / maxValue) * 250 : 0;
//             const arrearsHeight = maxValue > 0 ? (data[park].arrearAmount / maxValue) * 250 : 0;
            
//             return (
//               <Box key={park} sx={{ textAlign: 'center', minWidth: 140, cursor: 'pointer' }}>
//                 <Tooltip
//                   title={
//                     <Box sx={{ p: 1 }}>
//                       <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         Revenue: {currencySymbol}{formatNumber(data[park].revenueAmount)}
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff' }}>
//                         Arrears: {currencySymbol}{formatNumber(data[park].arrearAmount)}
//                       </Typography>
//                       <Typography variant="body2" sx={{ color: '#fff', fontWeight: 'bold' }}>
//                         Net Position: {data[park].netPosition >= 0 ? '+' : ''}{formatNumber(Math.abs(data[park].netPosition))} {data[park].netPosition >= 0 ? 'Surplus' : 'Deficit'}
//                       </Typography>
//                     </Box>
//                   }
//                   arrow
//                   placement="top"
//                 >
//                   <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 90 }}>
//                     <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.5, justifyContent: 'center' }}>
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Box sx={{ 
//                           height: revenueHeight, 
//                           width: '35px',
//                           bgcolor: '#2e7d32',
//                           borderRadius: '3px 3px 0 0',
//                           margin: '0 auto',
//                           transition: 'all 0.3s ease',
//                           '&:hover': { opacity: 0.8, transform: 'translateY(-5px)' }
//                         }} />
//                         <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontSize: '9px', color: '#2e7d32', fontWeight: 'bold' }}>
//                           Rev
//                         </Typography>
//                         <Typography variant="caption" sx={{ display: 'block', fontSize: '8px' }}>
//                           {formatNumber(data[park].revenueAmount)}
//                         </Typography>
//                       </Box>
//                       <Box sx={{ textAlign: 'center' }}>
//                         <Box sx={{ 
//                           height: arrearsHeight, 
//                           width: '35px',
//                           bgcolor: '#d32f2f',
//                           borderRadius: '3px 3px 0 0',
//                           margin: '0 auto',
//                           transition: 'all 0.3s ease',
//                           '&:hover': { opacity: 0.8, transform: 'translateY(-5px)' }
//                         }} />
//                         <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontSize: '9px', color: '#d32f2f', fontWeight: 'bold' }}>
//                           Arr
//                         </Typography>
//                         <Typography variant="caption" sx={{ display: 'block', fontSize: '8px' }}>
//                           {formatNumber(data[park].arrearAmount)}
//                         </Typography>
//                       </Box>
//                     </Box>
//                     <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontWeight: 'bold', fontSize: '9px' }}>
//                       {park.length > 12 ? park.substring(0, 10) + '...' : park}
//                     </Typography>
                    
//                   </Box>
//                 </Tooltip>
//               </Box>
//             );
//           })}
//         </Box>
        
//         <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 4, borderTop: '1px solid #e0e0e0', pt: 2 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Box sx={{ width: 20, height: 20, bgcolor: '#2e7d32', borderRadius: 1 }} />
//             <Typography variant="caption">Revenue Collected</Typography>
//           </Box>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Box sx={{ width: 20, height: 20, bgcolor: '#d32f2f', borderRadius: 1 }} />
//             <Typography variant="caption">Outstanding Arrears</Typography>
//           </Box>
//         </Box>
        
//         <Box sx={{ mt: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
//           <Grid container spacing={2}>
//             <Grid item xs={4}>
//               <Typography variant="caption" color="textSecondary">Total Revenue</Typography>
//               <Typography variant="body2" fontWeight="bold" color="#2e7d32">
//                 {currencySymbol}{formatNumber(Object.values(data).reduce((sum, d) => sum + d.revenueAmount, 0))}
//               </Typography>
//             </Grid>
//             <Grid item xs={4}>
//               <Typography variant="caption" color="textSecondary">Total Arrears</Typography>
//               <Typography variant="body2" fontWeight="bold" color="#d32f2f">
//                 {currencySymbol}{formatNumber(Object.values(data).reduce((sum, d) => sum + d.arrearAmount, 0))}
//               </Typography>
//             </Grid>
//             <Grid item xs={4}>
//               <Typography variant="caption" color="textSecondary">Net Position</Typography>
//               <Typography variant="body2" fontWeight="bold" color={Object.values(data).reduce((sum, d) => sum + (d.revenueAmount - d.arrearAmount), 0) >= 0 ? '#2e7d32' : '#d32f2f'}>
//                 {formatNumber(Math.abs(Object.values(data).reduce((sum, d) => sum + (d.revenueAmount - d.arrearAmount), 0)))} 
//                 {Object.values(data).reduce((sum, d) => sum + (d.revenueAmount - d.arrearAmount), 0) >= 0 ? ' Surplus' : ' Deficit'}
//               </Typography>
//             </Grid>
//           </Grid>
//         </Box>
//       </Box>
//     );
//   };

//   // Net Position Line Chart
//   const NetPositionChart = ({ data, title, currencySymbol }) => {
//     const parks = Object.keys(data);
//     const maxNet = Math.max(...parks.map(p => Math.abs(data[p].netPosition)), 1);
    
//     if (parks.length === 0) {
//       return (
//         <Box sx={{ p: 5, textAlign: 'center' }}>
//           <Typography variant="body2" color="textSecondary">No data available for {title}</Typography>
//         </Box>
//       );
//     }
    
//     const chartHeight = 350;
//     const chartWidth = Math.max(800, parks.length * 80);
//     const padding = { top: 30, right: 40, bottom: 80, left: 70 };
    
//     return (
//       <Box sx={{ p: 2, overflowX: 'auto' }}>
//         <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
//           {title}
//         </Typography>
        
//         <svg width={chartWidth} height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
//           {[-100, -75, -50, -25, 0, 25, 50, 75, 100].map((percent) => {
//             const y = chartHeight - padding.bottom - ((percent + 100) / 200) * (chartHeight - padding.top - padding.bottom);
//             const value = (maxNet * percent) / 100;
//             return (
//               <g key={percent}>
//                 <line x1={padding.left} y1={y} x2={chartWidth - padding.right} y2={y} stroke="#e0e0e0" strokeWidth="1" strokeDasharray="4" />
//                 <text x={padding.left - 8} y={y} textAnchor="end" fontSize="10" fill="#666">{formatNumber(value)}</text>
//               </g>
//             );
//           })}
          
//           <line x1={padding.left} y1={chartHeight - padding.bottom - (100 / 200) * (chartHeight - padding.top - padding.bottom)} x2={chartWidth - padding.right} y2={chartHeight - padding.bottom - (100 / 200) * (chartHeight - padding.top - padding.bottom)} stroke="#999" strokeWidth="2" strokeDasharray="8" />
          
//           <polyline points={parks.map((park, index) => {
//             const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
//             const normalizedValue = ((data[park].netPosition + maxNet) / (maxNet * 2)) * 100;
//             const y = chartHeight - padding.bottom - (normalizedValue / 100) * (chartHeight - padding.top - padding.bottom);
//             return `${x},${y}`;
//           }).join(' ')} fill="none" stroke="#1976d2" strokeWidth="2.5" />
          
//           {parks.map((park, index) => {
//             const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
//             const normalizedValue = ((data[park].netPosition + maxNet) / (maxNet * 2)) * 100;
//             const y = chartHeight - padding.bottom - (normalizedValue / 100) * (chartHeight - padding.top - padding.bottom);
//             const isPositive = data[park].netPosition >= 0;
            
//             return (
//               <g key={park}>
//                 <Tooltip title={<Box sx={{ p: 1 }}><Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography><Typography variant="body2" sx={{ color: '#fff' }}>Revenue: {formatNumber(data[park].revenueAmount)}</Typography><Typography variant="body2" sx={{ color: '#fff' }}>Arrears: {formatNumber(data[park].arrearAmount)}</Typography><Typography variant="body2" sx={{ color: '#fff', fontWeight: 'bold' }}>Net Position: {isPositive ? '+' : ''}{formatNumber(data[park].netPosition)}</Typography></Box>} arrow placement="top">
//                   <circle cx={x} cy={y} r="6" fill={isPositive ? '#2e7d32' : '#d32f2f'} stroke="white" strokeWidth="2" style={{ cursor: 'pointer' }} />
//                 </Tooltip>
//                 <text x={x} y={chartHeight - padding.bottom + 20} textAnchor="middle" fontSize="10" transform={`rotate(-45, ${x}, ${chartHeight - padding.bottom + 20})`}>
//                   {park.length > 15 ? park.substring(0, 12) + '...' : park}
//                 </text>
//               </g>
//             );
//           })}
          
//           <line x1={padding.left} y1={padding.top} x2={padding.left} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1.5" />
//           <line x1={padding.left} y1={chartHeight - padding.bottom} x2={chartWidth - padding.right} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1.5" />
//           <text x={25} y={chartHeight / 2} textAnchor="middle" fontSize="11" fill="#666" transform={`rotate(-90, 25, ${chartHeight / 2})`}>Net Position (Revenue - Arrears)</text>
//         </svg>
        
//         <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#2e7d32', borderRadius: '50%' }} /><Typography variant="caption">Positive Net Position (Surplus)</Typography></Box>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#d32f2f', borderRadius: '50%' }} /><Typography variant="caption">Negative Net Position (Deficit)</Typography></Box>
//         </Box>
//       </Box>
//     );
//   };

//   // Regular Bar Chart for Revenue or Arrears only
//   const RegularBarChart = ({ title, data, totalAmount, currencySymbol, type }) => {
//     const maxValue = Math.max(...Object.values(data).map(d => d.totalRevenue || d.totalArrears || 0), 0);
//     const parks = Object.keys(data);
    
//     if (parks.length === 0) {
//       return (
//         <Box sx={{ p: 5, textAlign: 'center' }}>
//           <Typography variant="body2" color="textSecondary">No {title} data available</Typography>
//         </Box>
//       );
//     }
    
//     return (
//       <Box sx={{ p: 2 }}>
//         <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', textAlign: 'center', mb: 3 }}>
//           {title} - Total: {currencySymbol}{formatNumber(totalAmount)}
//         </Typography>
        
//         <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 350, justifyContent: 'center', flexWrap: 'wrap' }}>
//           {Object.entries(data).map(([park, parkData]) => {
//             const value = parkData.totalRevenue || parkData.totalArrears || 0;
//             const height = maxValue > 0 ? (value / maxValue) * 250 : 0;
//             const color = type === 'revenue' ? '#2e7d32' : '#d32f2f';
            
//             return (
//               <Tooltip key={park} title={`${park}: ${currencySymbol}${formatNumber(value)}`} arrow placement="top">
//                 <Box sx={{ textAlign: 'center', flex: 1, minWidth: 80, cursor: 'pointer' }}>
//                   <Box sx={{ height: height, width: '70px', bgcolor: color, borderRadius: '4px 4px 0 0', margin: '0 auto', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8, transform: 'translateY(-5px)' } }} />
//                   <Typography variant="caption" sx={{ mt: 1, display: 'block', fontWeight: 'bold' }}>
//                     {park.length > 12 ? park.substring(0, 10) + '...' : park}
//                   </Typography>
//                   <Typography variant="caption" color="textSecondary">
//                     {currencySymbol}{formatNumber(value)}
//                   </Typography>
//                 </Box>
//               </Tooltip>
//             );
//           })}
//         </Box>
        
//         <Box sx={{ mt: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1, textAlign: 'center' }}>
//           <Typography variant="body2" color="textSecondary">
//             Number of Parks: {parks.length} | Total Amount: {currencySymbol}{formatNumber(totalAmount)}
//           </Typography>
//         </Box>
//       </Box>
//     );
//   };

//   // Get separate currency data for charts
//   const getCurrencySpecificData = () => {
//     const usdData = getComparisonChartData("usd");
//     const birrData = getComparisonChartData("birr");
    
//     const usdRevenueTotal = filteredRevenueData
//       .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//       .reduce((sum, item) => sum + (item.amount || 0), 0);
    
//     const birrRevenueTotal = filteredRevenueData
//       .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//       .reduce((sum, item) => sum + (item.amount || 0), 0);
    
//     const usdArrearTotal = filteredArrearsData
//       .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//       .reduce((sum, item) => sum + (item.outstanding || 0), 0);
    
//     const birrArrearTotal = filteredArrearsData
//       .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//       .reduce((sum, item) => sum + (item.outstanding || 0), 0);
    
//     return {
//       usd: { data: usdData, revenueTotal: usdRevenueTotal, arrearTotal: usdArrearTotal },
//       birr: { data: birrData, revenueTotal: birrRevenueTotal, arrearTotal: birrArrearTotal }
//     };
//   };

//   // Render Chart based on currency selection and comparison type
//   const renderChart = () => {
//     if (selectedCurrency === "usd") {
//       const usdData = getComparisonChartData("usd");
//       const usdRevenueTotal = filteredRevenueData
//         .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//         .reduce((sum, item) => sum + (item.amount || 0), 0);
//       const usdArrearTotal = filteredArrearsData
//         .filter(item => normalizeCurrency(item.payment_mode) === "usd")
//         .reduce((sum, item) => sum + (item.outstanding || 0), 0);
      
//       if (comparisonType === 'revenue') {
//         const revenueChartData = {};
//         Object.entries(usdData).forEach(([park, parkData]) => {
//           revenueChartData[park] = { totalRevenue: parkData.revenueAmount };
//         });
//         return (
//           <RegularBarChart 
//             title={`Revenue Distribution by Park (USD)`}
//             data={revenueChartData} 
//             totalAmount={usdRevenueTotal}
//             currencySymbol="$"
//             type="revenue"
//           />
//         );
//       } else if (comparisonType === 'arrears') {
//         const arrearChartData = {};
//         Object.entries(usdData).forEach(([park, parkData]) => {
//           arrearChartData[park] = { totalArrears: parkData.arrearAmount };
//         });
//         return (
//           <RegularBarChart 
//             title={`Arrears Distribution by Park (USD)`}
//             data={arrearChartData} 
//             totalAmount={usdArrearTotal}
//             currencySymbol="$"
//             type="arrears"
//           />
//         );
//       } else if (comparisonType === 'comparison' && chartType === 'bar') {
//         return <ComparisonBarChart data={usdData} title="Revenue vs Arrears by Park (USD)" currencySymbol="$" />;
//       } else {
//         return <NetPositionChart data={usdData} title="Net Financial Position by Park (USD)" currencySymbol="$" />;
//       }
//     } 
//     else if (selectedCurrency === "birr") {
//       const birrData = getComparisonChartData("birr");
//       const birrRevenueTotal = filteredRevenueData
//         .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//         .reduce((sum, item) => sum + (item.amount || 0), 0);
//       const birrArrearTotal = filteredArrearsData
//         .filter(item => normalizeCurrency(item.payment_mode) === "birr")
//         .reduce((sum, item) => sum + (item.outstanding || 0), 0);
      
//       if (comparisonType === 'revenue') {
//         const revenueChartData = {};
//         Object.entries(birrData).forEach(([park, parkData]) => {
//           revenueChartData[park] = { totalRevenue: parkData.revenueAmount };
//         });
//         return (
//           <RegularBarChart 
//             title={`Revenue Distribution by Park (ETB)`}
//             data={revenueChartData} 
//             totalAmount={birrRevenueTotal}
//             currencySymbol="ETB"
//             type="revenue"
//           />
//         );
//       } else if (comparisonType === 'arrears') {
//         const arrearChartData = {};
//         Object.entries(birrData).forEach(([park, parkData]) => {
//           arrearChartData[park] = { totalArrears: parkData.arrearAmount };
//         });
//         return (
//           <RegularBarChart 
//             title={`Arrears Distribution by Park (ETB)`}
//             data={arrearChartData} 
//             totalAmount={birrArrearTotal}
//             currencySymbol="ETB"
//             type="arrears"
//           />
//         );
//       } else if (comparisonType === 'comparison' && chartType === 'bar') {
//         return <ComparisonBarChart data={birrData} title="Revenue vs Arrears by Park (ETB)" currencySymbol="ETB" />;
//       } else {
//         return <NetPositionChart data={birrData} title="Net Financial Position by Park (ETB)" currencySymbol="ETB" />;
//       }
//     }
//     else {
//       // When "All" currencies is selected, show side by side charts
//       const currencyData = getCurrencySpecificData();
      
//       if (comparisonType === 'revenue') {
//         const usdRevenueChartData = {};
//         const birrRevenueChartData = {};
        
//         Object.entries(currencyData.usd.data).forEach(([park, parkData]) => {
//           usdRevenueChartData[park] = { totalRevenue: parkData.revenueAmount };
//         });
//         Object.entries(currencyData.birr.data).forEach(([park, parkData]) => {
//           birrRevenueChartData[park] = { totalRevenue: parkData.revenueAmount };
//         });
        
//         return (
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={6}>
//               <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
//                 <RegularBarChart 
//                   title={`Revenue Distribution by Park (USD)`}
//                   data={usdRevenueChartData} 
//                   totalAmount={currencyData.usd.revenueTotal}
//                   currencySymbol="$"
//                   type="revenue"
//                 />
//               </Paper>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
//                 <RegularBarChart 
//                   title={`Revenue Distribution by Park (ETB)`}
//                   data={birrRevenueChartData} 
//                   totalAmount={currencyData.birr.revenueTotal}
//                   currencySymbol="ETB"
//                   type="revenue"
//                 />
//               </Paper>
//             </Grid>
//           </Grid>
//         );
//       } 
//       else if (comparisonType === 'arrears') {
//         const usdArrearChartData = {};
//         const birrArrearChartData = {};
        
//         Object.entries(currencyData.usd.data).forEach(([park, parkData]) => {
//           usdArrearChartData[park] = { totalArrears: parkData.arrearAmount };
//         });
//         Object.entries(currencyData.birr.data).forEach(([park, parkData]) => {
//           birrArrearChartData[park] = { totalArrears: parkData.arrearAmount };
//         });
        
//         return (
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={6}>
//               <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
//                 <RegularBarChart 
//                   title={`Arrears Distribution by Park (USD)`}
//                   data={usdArrearChartData} 
//                   totalAmount={currencyData.usd.arrearTotal}
//                   currencySymbol="$"
//                   type="arrears"
//                 />
//               </Paper>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
//                 <RegularBarChart 
//                   title={`Arrears Distribution by Park (ETB)`}
//                   data={birrArrearChartData} 
//                   totalAmount={currencyData.birr.arrearTotal}
//                   currencySymbol="ETB"
//                   type="arrears"
//                 />
//               </Paper>
//             </Grid>
//           </Grid>
//         );
//       }
//       else if (comparisonType === 'comparison' && chartType === 'bar') {
//         return (
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={6}>
//               <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
//                 <ComparisonBarChart data={currencyData.usd.data} title="Revenue vs Arrears by Park (USD)" currencySymbol="$" />
//               </Paper>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
//                 <ComparisonBarChart data={currencyData.birr.data} title="Revenue vs Arrears by Park (ETB)" currencySymbol="ETB" />
//               </Paper>
//             </Grid>
//           </Grid>
//         );
//       }
//       else {
//         return (
//           <Grid container spacing={3}>
//             <Grid item xs={12} md={6}>
//               <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
//                 <NetPositionChart data={currencyData.usd.data} title="Net Financial Position by Park (USD)" currencySymbol="$" />
//               </Paper>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
//                 <NetPositionChart data={currencyData.birr.data} title="Net Financial Position by Park (ETB)" currencySymbol="ETB" />
//               </Paper>
//             </Grid>
//           </Grid>
//         );
//       }
//     }
//   };

//   const loading = revenueLoading || arrearsLoading;

//   // Handle chart type change
//   const handleChartTypeChange = (event, newChartType) => {
//     if (newChartType !== null) {
//       setChartType(newChartType);
//     }
//   };

//   return (
//     <Box sx={{ width: '100%', bgcolor: '#f5f5f5', minHeight: '100vh', p: 3 }}>
//       {/* Header Section */}
//       <Typography variant="h5" gutterBottom sx={{ color: '#1a237e', fontWeight: 'bold', textAlign: 'center', mb: 1 }}>
//         Financial Performance Dashboard
//       </Typography>
//       <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', mb: 3 }}>
//         Revenue Collection vs Outstanding Arrears Analysis
//       </Typography>
      
//       {/* Summary Cards */}
//       <Grid container spacing={1.5} sx={{ mb: 2 }}>
//         {/* Total Revenue Card */}
//         <Grid item xs={12} sm={4} md={3}>
//           <Card sx={{ bgcolor: '#e8f5e9', boxShadow: 2 }}>
//             <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
//               <Box display="flex" alignItems="center" justifyContent="space-between" gap={0.5}>
//                 <Box sx={{ flex: 1 }}>
//                   <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold', fontSize: '0.6rem', display: 'block' }}>Revenue</Typography>
//                   <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 'bold', fontSize: '0.7rem', lineHeight: 1.2 }}>
//                     {selectedCurrency === "usd" ? `$${formatNumber(revenueTotalUSD)}` : 
//                      selectedCurrency === "birr" ? `${formatNumber(revenueTotalETB)} ETB` : 
//                      `$${formatNumber(revenueTotalUSD)}`}
//                     {selectedCurrency === "all" && ` / ${formatNumber(revenueTotalETB)} ETB`}
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: '#999', fontSize: '0.55rem', display: 'block' }}>
//                     {revenueStats.totalTransactions} Txs | {revenueStats.uniqueCompanies} Co.
//                   </Typography>
//                 </Box>
//                 <TrendingUpIcon sx={{ fontSize: 24, color: '#2e7d32' }} />
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>
        
//         {/* Total Arrears Card */}
//         <Grid item xs={12} sm={4} md={3}>
//           <Card sx={{ bgcolor: '#ffebee', boxShadow: 2 }}>
//             <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
//               <Box display="flex" alignItems="center" justifyContent="space-between" gap={0.5}>
//                 <Box sx={{ flex: 1 }}>
//                   <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold', fontSize: '0.6rem', display: 'block' }}>Arrears</Typography>
//                   <Typography variant="body2" sx={{ color: '#d32f2f', fontWeight: 'bold', fontSize: '0.7rem', lineHeight: 1.2 }}>
//                     {selectedCurrency === "usd" ? `$${formatNumber(arrearTotalUSD)}` : 
//                      selectedCurrency === "birr" ? `${formatNumber(arrearTotalETB)} ETB` : 
//                      `$${formatNumber(arrearTotalUSD)}`}
//                     {selectedCurrency === "all" && ` / ${formatNumber(arrearTotalETB)} ETB`}
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: '#999', fontSize: '0.55rem', display: 'block' }}>
//                     {arrearStats.totalCompanies} Accts | {arrearStats.criticalAccounts} Critical
//                   </Typography>
//                 </Box>
//                 <WarningIcon sx={{ fontSize: 24, color: '#d32f2f' }} />
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>
        
//         {/* Net USD Position Card */}
//         <Grid item xs={12} sm={4} md={3}>
//           <Card sx={{ bgcolor: revenueTotalUSD - arrearTotalUSD >= 0 ? '#e8f5e9' : '#ffebee', boxShadow: 2 }}>
//             <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
//               <Box display="flex" alignItems="center" justifyContent="space-between" gap={0.5}>
//                 <Box sx={{ flex: 1 }}>
//                   <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold', fontSize: '0.6rem', display: 'block' }}>Net USD</Typography>
//                   <Typography variant="body2" sx={{ color: revenueTotalUSD - arrearTotalUSD >= 0 ? '#2e7d32' : '#d32f2f', fontWeight: 'bold', fontSize: '0.7rem', lineHeight: 1.2 }}>
//                     {revenueTotalUSD - arrearTotalUSD >= 0 ? '+' : ''}{formatNumber(Math.abs(revenueTotalUSD - arrearTotalUSD))}
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: '#666', fontSize: '0.55rem', display: 'block' }}>
//                     ${formatNumber(revenueTotalUSD)} - ${formatNumber(arrearTotalUSD)}
//                   </Typography>
//                 </Box>
//                 <TrendingUpIcon sx={{ fontSize: 24, color: revenueTotalUSD - arrearTotalUSD >= 0 ? '#2e7d32' : '#d32f2f' }} />
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>
        
//         {/* Net ETB Position Card */}
//         <Grid item xs={12} sm={4} md={3}>
//           <Card sx={{ bgcolor: revenueTotalETB - arrearTotalETB >= 0 ? '#e8f5e9' : '#ffebee', boxShadow: 2 }}>
//             <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
//               <Box display="flex" alignItems="center" justifyContent="space-between" gap={0.5}>
//                 <Box sx={{ flex: 1 }}>
//                   <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold', fontSize: '0.6rem', display: 'block' }}>Net ETB</Typography>
//                   <Typography variant="body2" sx={{ color: revenueTotalETB - arrearTotalETB >= 0 ? '#2e7d32' : '#d32f2f', fontWeight: 'bold', fontSize: '0.7rem', lineHeight: 1.2 }}>
//                     {revenueTotalETB - arrearTotalETB >= 0 ? '+' : ''}{formatNumber(Math.abs(revenueTotalETB - arrearTotalETB))}
//                   </Typography>
//                   <Typography variant="caption" sx={{ color: '#666', fontSize: '0.55rem', display: 'block' }}>
//                     {formatNumber(revenueTotalETB)} - {formatNumber(arrearTotalETB)} ETB
//                   </Typography>
//                 </Box>
//                 <AccountBalanceIcon sx={{ fontSize: 24, color: revenueTotalETB - arrearTotalETB >= 0 ? '#2e7d32' : '#d32f2f' }} />
//               </Box>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Grid>
      
//       {/* Filters Section */}
//       <Paper elevation={2} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={4}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder="Search..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               InputProps={{
//                 startAdornment: (<InputAdornment position="start"><SearchIcon /></InputAdornment>),
//                 endAdornment: searchTerm && (<InputAdornment position="end"><ClearIcon sx={{ cursor: 'pointer' }} onClick={() => setSearchTerm("")} /></InputAdornment>)
//               }}
//             />
//           </Grid>
          
//           <Grid item xs={12} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Park</InputLabel>
//               <Select value={selectedPark} onChange={(e) => setSelectedPark(e.target.value)} label="Park">
//                 <MenuItem value="all">All Parks</MenuItem>
//                 {parksList.map((park) => (<MenuItem key={park} value={park}>{park}</MenuItem>))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           {/* Year From Dropdown */}
//           <Grid item xs={12} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Year From</InputLabel>
//               <Select value={startYear} onChange={(e) => setStartYear(e.target.value)} label="Year From">
//                 {years.map((year) => (<MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           {/* Year To Dropdown */}
//           <Grid item xs={12} md={1.5}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Year To</InputLabel>
//               <Select value={endYear} onChange={(e) => setEndYear(e.target.value)} label="Year To">
//                 {years.map((year) => (<MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           {/* Month From */}
//           <Grid item xs={12} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Month From</InputLabel>
//               <Select value={startMonth} onChange={(e) => setStartMonth(e.target.value)} label="Month From">
//                 {months.map((month) => (<MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           {/* Month To */}
//           <Grid item xs={12} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Month To</InputLabel>
//               <Select value={endMonth} onChange={(e) => setEndMonth(e.target.value)} label="Month To">
//                 {months.map((month) => (<MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>))}
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Currency Dropdown */}
//           <Grid item xs={12} md={2}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Currency</InputLabel>
//               <Select value={selectedCurrency} onChange={(e) => setSelectedCurrency(e.target.value)} label="Currency">
//                 <MenuItem value="all">All</MenuItem>
//                 <MenuItem value="usd">USD</MenuItem>
//                 <MenuItem value="birr">Birr</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} md={2}>
//             <Box sx={{ display: 'flex', gap: 1 }}>
//               <Button fullWidth variant="outlined" onClick={resetFilters} startIcon={<ClearIcon />} size="small" sx={{ textTransform: 'none', borderColor: '#1976d2', color: '#1976d2', '&:hover': { borderColor: '#1565c0', backgroundColor: 'rgba(25, 118, 210, 0.04)' } }}>
//                 Reset
//               </Button>
//               <Button
//                 fullWidth
//                 variant="contained"
//                 color="inherit"
//                 size="small"
//                 onClick={handleExportCSV}
//                 startIcon={<DownloadIcon />}
//                 sx={{ textTransform: 'none' }}
//               >
//                 Export
//               </Button>
//             </Box>
//           </Grid>
//         </Grid>
        
//         {/* Chart Controls Row */}
//         <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
//           <Grid item xs={12} md={3}>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//               <Typography variant="body2" color="textSecondary">View:</Typography>
//               <ToggleButtonGroup value={comparisonType} exclusive onChange={(e, val) => val && setComparisonType(val)} size="small">
//                 <ToggleButton value="revenue"><Tooltip title="Revenue Only"><ReceiptIcon fontSize="small" /></Tooltip></ToggleButton>
//                 <ToggleButton value="arrears"><Tooltip title="Arrears Only"><WarningIcon fontSize="small" /></Tooltip></ToggleButton>
//                 <ToggleButton value="comparison"><Tooltip title="Revenue vs Arrears"><CompareIcon fontSize="small" /></Tooltip></ToggleButton>
//               </ToggleButtonGroup>
//             </Box>
//           </Grid>
          
//           {comparisonType === 'comparison' && (
//             <Grid item xs={12} md={3}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                 <Typography variant="body2" color="textSecondary">Chart Type:</Typography>
//                 <ToggleButtonGroup value={chartType} exclusive onChange={handleChartTypeChange} size="small">
//                   <ToggleButton value="bar"><Tooltip title="Bar Chart"><BarChartIcon fontSize="small" /></Tooltip></ToggleButton>
//                   <ToggleButton value="line"><Tooltip title="Line Chart"><ShowChartIcon fontSize="small" /></Tooltip></ToggleButton>
//                 </ToggleButtonGroup>

//                 <Button 
//                 variant="outlined" 
//                 size="small" 
//                 onClick={() => setShowChart(!showChart)} 
//                 sx={{ 
//                   minWidth: '120px', 
//                   textTransform: 'none',
//                   borderColor: '#1976d2',
//                   color: '#1976d2',
//                   '&:hover': { 
//                     borderColor: '#1976d2',
//                     backgroundColor: '#f5f5f5',
//                     color: '#1976d2'
//                   } 
//                 }}
//               >
//                 {showChart ? "Hide Chart" : "Show Chart"}
//               </Button>
//               </Box>
//             </Grid>
//           )}
          
//           <Grid item xs={12} md={comparisonType === 'comparison' ? 6 : 9}>
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
             
//             </Box>
//           </Grid>
//         </Grid>
//       </Paper>
      
//       {/* Conditional Rendering: Show Chart OR Table */}
//       {showChart ? (
//         <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mb: 3 }}>
//           {!loading && renderChart()}
//         </Paper>
//       ) : (
//         <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
//           <Box sx={{ p: 2, bgcolor: '#fafafa', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//             <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Financial Records (Revenue & Arrears)</Typography>
//             <Typography variant="body2" color="textSecondary">Showing {getTotalCombinedCount()} total records</Typography>
//           </Box>
          
//           <TableContainer>
//             <Table size="small">
//               <TableHead sx={{ bgcolor: '#f5f5f5' }}>
//                 <TableRow>
//                   <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold' }}>ID</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold' }}>Company</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold' }}>Park</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold' }}>Currency</TableCell>
//                   <TableCell align="right" sx={{ fontWeight: 'bold' }}>Amount</TableCell>
//                   <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
//                   <TableCell align="center" sx={{ fontWeight: 'bold' }}>Actions</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {loading ? (
//                   <TableRow><TableCell colSpan={8} align="center"><CircularProgress size={40} /><Typography sx={{ mt: 1 }}>Loading...</Typography></TableCell></TableRow>
//                 ) : getCombinedTableData().length === 0 ? (
//                   <TableRow><TableCell colSpan={8} align="center"><Typography sx={{ py: 3 }}>No records found</Typography></TableCell></TableRow>
//                 ) : (
//                   getCombinedTableData().map((item, index) => (
//                     <TableRow key={`${item.type}-${item.id}-${index}`} hover>
//                       <TableCell>{item.type === 'revenue' ? 'Revenue' : 'Arrear'}</TableCell>
//                       <TableCell>{item.id}</TableCell>
//                       <TableCell>{item.company_name}</TableCell>
//                       <TableCell>{item.park_name}</TableCell>
//                       <TableCell>{item.payment_mode}</TableCell>
//                       <TableCell align="right" sx={{ color: item.type === 'revenue' ? '#2e7d32' : '#d32f2f', fontWeight: 'bold' }}>{item.formattedAmount}</TableCell>
//                       <TableCell>{item.date}</TableCell>
//                       <TableCell align="center">
//                         <Tooltip title="View Details">
//                           <IconButton size="small" color="primary" onClick={() => { setSelectedItem(item.rawData); setDetailsType(item.type); setOpenDetailsDialog(true); }}>
//                             <VisibilityIcon />
//                           </IconButton>
//                         </Tooltip>
//                       </TableCell>
//                     </TableRow>
//                   ))
//                 )}
//               </TableBody>
//             </Table>
//           </TableContainer>
          
//           <TablePagination rowsPerPageOptions={[5, 10, 25, 50]} component="div" count={getTotalCombinedCount()} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
//         </Paper>
//       )}
      
//       {/* Details Dialog */}
//       <Dialog open={openDetailsDialog} onClose={() => setOpenDetailsDialog(false)} maxWidth="md" fullWidth>
//         <DialogTitle><Box display="flex" justifyContent="space-between" alignItems="center"><Typography variant="h5" sx={{ fontWeight: 'bold' }}>{detailsType === 'revenue' ? 'Revenue Transaction Details' : 'Arrear Details'}</Typography><IconButton onClick={() => setOpenDetailsDialog(false)}><CloseIcon /></IconButton></Box></DialogTitle>
//         <Divider />
//         <DialogContent>
//           {selectedItem && (
//             <Box sx={{ mt: 2 }}>
//               <Grid container spacing={2}>
//                 {detailsType === 'revenue' ? (
//                   <>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Transaction ID:</Typography><Typography variant="body2">{selectedItem.transaction_id}</Typography></Grid>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Company Name:</Typography><Typography variant="body2">{selectedItem.company_name}</Typography></Grid>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Park Name:</Typography><Typography variant="body2">{selectedItem.park_name}</Typography></Grid>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Payment Mode:</Typography><Typography variant="body2">{selectedItem.payment_mode}</Typography></Grid>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Amount:</Typography><Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 'bold' }}>{selectedItem.formattedAmount}</Typography></Grid>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Transaction Date:</Typography><Typography variant="body2">{selectedItem.transaction_date_formatted}</Typography></Grid>
//                     <Grid item xs={12}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Description:</Typography><Typography variant="body2">{selectedItem.description}</Typography></Grid>
//                   </>
//                 ) : (
//                   <>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Agreement ID:</Typography><Typography variant="body2">{selectedItem.agreement_id}</Typography></Grid>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Company Name:</Typography><Typography variant="body2">{selectedItem.company_name}</Typography></Grid>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Park Name:</Typography><Typography variant="body2">{selectedItem.park_name}</Typography></Grid>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Due Date:</Typography><Typography variant="body2">{selectedItem.due_date_formatted}</Typography></Grid>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Days Overdue:</Typography><Typography variant="body2">{selectedItem.overdue_days > 0 ? `${selectedItem.overdue_days} days` : 'Current'}</Typography></Grid>
//                     <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Status:</Typography><Chip label={selectedItem.status} size="small" color={selectedItem.statusColor} /></Grid>
//                     <Grid item xs={12}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Outstanding Balance:</Typography><Typography variant="body2" sx={{ color: '#d32f2f', fontWeight: 'bold' }}>{selectedItem.formattedOutstanding}</Typography></Grid>
//                   </>
//                 )}
//               </Grid>
//             </Box>
//           )}
//         </DialogContent>
//         <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}><Button onClick={() => setOpenDetailsDialog(false)} variant="outlined">Close</Button></Box>
//       </Dialog>
//     </Box>
//   );
// }
//******************************************************************************************* */
import { useEffect, useState, useCallback } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Chip,
  Divider,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  ToggleButton,
  ToggleButtonGroup
} from "@mui/material";
import {
  Search as SearchIcon,
  Clear as ClearIcon,
  Download as DownloadIcon,
  Visibility as VisibilityIcon,
  Close as CloseIcon,
  BarChart as BarChartIcon,
  ShowChart as ShowChartIcon,
  TrendingUp as TrendingUpIcon,
  WarningAmber as WarningIcon,
  Receipt as ReceiptIcon,
  AccountBalance as AccountBalanceIcon,
  CompareArrows as CompareIcon
} from "@mui/icons-material";
import { format } from "date-fns";
import { GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";

// Helper function to normalize currency values
const normalizeCurrency = (paymentMode) => {
  if (!paymentMode) return "unknown";
  const mode = paymentMode.toLowerCase();
  if (mode === "usd") return "usd";
  if (mode === "birr" || mode === "etb") return "birr";
  return mode;
};

// Helper function to convert to number
const toNumber = (value) => {
  if (typeof value === 'number' && !isNaN(value)) return value;
  if (typeof value === 'string') {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  }
  return 0;
};

// Format number with K, M, B abbreviations for data visualization (Cards only)
const formatNumberWithAbbreviation = (number) => {
  const num = toNumber(number);
  if (num === 0) return "0";
  
  const absNum = Math.abs(num);
  let formattedValue;
  let suffix = '';
  
  if (absNum >= 1e9) {
    formattedValue = (num / 1e9).toFixed(1);
    suffix = 'B';
  } else if (absNum >= 1e6) {
    formattedValue = (num / 1e6).toFixed(1);
    suffix = 'M';
  } else if (absNum >= 1e3) {
    formattedValue = (num / 1e3).toFixed(1);
    suffix = 'K';
  } else {
    formattedValue = num.toFixed(0);
  }
  
  // Remove .0 if it exists
  if (formattedValue.endsWith('.0')) {
    formattedValue = formattedValue.slice(0, -2);
  }
  
  return formattedValue + suffix;
};

// Format for card display with abbreviations
const formatCurrencyForCard = (amount, paymentMode) => {
  if (!amount && amount !== 0) return "0";
  
  const normalizedMode = normalizeCurrency(paymentMode);
  const formatted = formatNumberWithAbbreviation(amount);
  
  if (normalizedMode === "usd") {
    return `$${formatted}`;
  } else {
    return `${formatted} ETB`;
  }
};

export default function FinancialComparisonReport() {
  // Revenue States
  const [revenueData, setRevenueData] = useState([]);
  const [filteredRevenueData, setFilteredRevenueData] = useState([]);
  const [revenueLoading, setRevenueLoading] = useState(true);
  
  // Arrear States
  const [arrearsData, setArrearsData] = useState([]);
  const [filteredArrearsData, setFilteredArrearsData] = useState([]);
  const [arrearsLoading, setArrearsLoading] = useState(true);
  
  // Common Filter States
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPark, setSelectedPark] = useState("all");
  const [startYear, setStartYear] = useState("all");
  const [endYear, setEndYear] = useState("all");
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [startMonth, setStartMonth] = useState("all");
  const [endMonth, setEndMonth] = useState("all");
  const [selectedCurrency, setSelectedCurrency] = useState("all");
  const [parksList, setParksList] = useState([]);
  
  // Chart States
  const [chartType, setChartType] = useState('bar');
  const [comparisonType, setComparisonType] = useState('comparison');
  const [showChart, setShowChart] = useState(false);
  
  // Table Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // Dialog States
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [detailsType, setDetailsType] = useState('revenue');

  // Years and Months
  // Generate last 10 years dynamically
const getLastNYears = (n) => {
    const currentYear = new Date().getFullYear();
    const years = ["all"];
    for (let i = 0; i < n; i++) {
      years.push((currentYear - i).toString());
    }
    return years;
  };
  
  // Usage in your component
  const years = getLastNYears(10);
  const months = [
    { value: "all", label: "All Months" },
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" }
  ];

  // Utility Functions
  const formatNumber = (number) => {
    let num = 0;
    if (number !== null && number !== undefined) {
      if (typeof number === 'string') {
        const cleaned = number.replace(/[$,]/g, '');
        num = parseFloat(cleaned);
      } else {
        num = parseFloat(number);
      }
      if (isNaN(num)) num = 0;
    }
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    try {
      return format(new Date(date), 'dd/MM/yyyy');
    } catch {
      return "Invalid Date";
    }
  };

  const formatCurrency = (amount, paymentMode) => {
    const formatted = formatNumber(amount);
    const normalizedMode = normalizeCurrency(paymentMode);
    
    if (normalizedMode === "usd") {
      return `$${formatted}`;
    } else {
      return `${formatted} ETB`;
    }
  };

  const getStatusColor = (overdueDays) => {
    if (overdueDays >= 90) return "error";
    if (overdueDays >= 60) return "warning";
    if (overdueDays >= 30) return "info";
    if (overdueDays >= 1) return "warning";
    return "success";
  };

  const getStatusText = (overdueDays) => {
    if (overdueDays >= 90) return "Critical";
    if (overdueDays >= 60) return "Severe";
    if (overdueDays >= 30) return "Moderate";
    if (overdueDays >= 1) return "Mild";
    return "Current";
  };

  // Fetch Revenue Data
  useEffect(() => {
    const fetchRevenue = async () => {
      setRevenueLoading(true);
      try {
        const resultData = await GetDataFromApiWithParams(`finances/revenuereport`);
        let dataArray = [];
        
        if (resultData && Array.isArray(resultData)) {
          dataArray = resultData;
        } else if (resultData && resultData.data && Array.isArray(resultData.data)) {
          dataArray = resultData.data;
        } else if (resultData && resultData.results && Array.isArray(resultData.results)) {
          dataArray = resultData.results;
        } else if (resultData && resultData.items && Array.isArray(resultData.items)) {
          dataArray = resultData.items;
        } else if (resultData && resultData.records && Array.isArray(resultData.records)) {
          dataArray = resultData.records;
        } else if (resultData && typeof resultData === 'object') {
          for (let key in resultData) {
            if (Array.isArray(resultData[key])) {
              dataArray = resultData[key];
              break;
            }
          }
        }
        
        if (dataArray.length > 0) {
          const formattedData = dataArray.map((item, index) => {
            let revenueAmount = 0;
            
            if (item.payment_amount !== undefined && item.payment_amount !== null) {
              revenueAmount = parseFloat(item.payment_amount) || 0;
            } else if (item.amount !== undefined && item.amount !== null) {
              revenueAmount = parseFloat(item.amount) || 0;
            } else if (item.revenue !== undefined && item.revenue !== null) {
              revenueAmount = parseFloat(item.revenue) || 0;
            }
            
            let paymentMode = "ETB";
            if (item.payment_mode) {
              paymentMode = item.payment_mode;
            } else if (item.currency) {
              paymentMode = item.currency;
            }
            
            let transactionDate = item.transaction_date || item.date || item.payment_date || item.created_at;
            let month = item.month;
            let year = item.year;
            
            if (transactionDate && !month) {
              try {
                const dateObj = new Date(transactionDate);
                if (!isNaN(dateObj.getTime())) {
                  month = format(dateObj, 'MM');
                  year = format(dateObj, 'yyyy');
                }
              } catch (e) {}
            }
            
            return {
              id: item.id || item.revenue_id || item.transaction_id || index,
              transaction_id: item.transaction_id || item.id || `TRX-${index}`,
              company_name: item.company_name || item.tenant_name || item.customer_name || "N/A",
              park_name: item.park || item.park_name || item.location || "N/A",
              payment_mode: paymentMode,
              amount: revenueAmount,
              formattedAmount: formatCurrency(revenueAmount, paymentMode),
              transaction_date: transactionDate,
              transaction_date_formatted: transactionDate ? formatDate(transactionDate) : "N/A",
              revenue_type: item.payment_type || item.revenue_type || item.type || item.category || "Rent",
              payment_status: item.payment_status || item.status || "Completed",
              invoice_number: item.invoice_number || item.invoice_no || `INV-${index}`,
              description: item.description || item.notes || `Revenue from ${item.company_name || 'Unknown'}`,
              month: month || "01",
              year: year || "2024"
            };
          });
          
          setRevenueData(formattedData);
          setFilteredRevenueData(formattedData);
          
          const uniqueParks = [...new Set(formattedData.map(item => item.park_name).filter(Boolean))];
          setParksList(uniqueParks);
        }
      } catch (error) {
        console.error("Failed to fetch revenue data:", error);
      } finally {
        setRevenueLoading(false);
      }
    };
    
    fetchRevenue();
  }, []);

  // Fetch Arrear Data
  useEffect(() => {
    const fetchArrear = async () => {
      setArrearsLoading(true);
      try {
        const resultData = await GetDataFromApiWithParams(`finances/arrearreport`);
        
        if (resultData && Array.isArray(resultData)) {
          const formattedData = resultData.map(item => {
            const overdueDays = item.overdue_date || 0;
            const outstandingAmount = parseFloat(item.outstanding) || 0;
            const paymentMode = item.payment_mode || "ETB";
            
            // Extract year and month from due_date
            let year = "2024";
            let month = "01";
            if (item.due_date) {
              try {
                const dateObj = new Date(item.due_date);
                if (!isNaN(dateObj.getTime())) {
                  year = format(dateObj, 'yyyy');
                  month = format(dateObj, 'MM');
                }
              } catch (e) {}
            }
            
            return {
              id: item.agreement_id,
              agreement_id: item.agreement_id,
              company_name: item.company_name || "N/A",
              park_name: item.park || "N/A",
              payment_mode: paymentMode,
              outstanding: outstandingAmount,
              formattedOutstanding: formatCurrency(outstandingAmount, paymentMode),
              due_date: item.due_date,
              due_date_formatted: formatDate(item.due_date),
              overdue_days: overdueDays,
              status: getStatusText(overdueDays),
              statusColor: getStatusColor(overdueDays),
              description: `Arrears for ${item.company_name}`,
              month: month,
              year: year
            };
          });
          
          setArrearsData(formattedData);
          setFilteredArrearsData(formattedData);
          
          const uniqueParks = [...new Set(formattedData.map(item => item.park_name).filter(Boolean))];
          setParksList(prev => [...new Set([...prev, ...uniqueParks])]);
        }
      } catch (error) {
        console.error("Failed to fetch arrear data:", error);
      } finally {
        setArrearsLoading(false);
      }
    };
    
    fetchArrear();
  }, []);

  // Calculate Summary Statistics with Currency Filter
  const revenueTotalUSD = filteredRevenueData
    .filter(item => normalizeCurrency(item.payment_mode) === "usd")
    .reduce((sum, item) => sum + (item.amount || 0), 0);

  const revenueTotalETB = filteredRevenueData
    .filter(item => normalizeCurrency(item.payment_mode) === "birr")
    .reduce((sum, item) => sum + (item.amount || 0), 0);

  const arrearTotalUSD = filteredArrearsData
    .filter(item => normalizeCurrency(item.payment_mode) === "usd")
    .reduce((sum, item) => sum + (item.outstanding || 0), 0);

  const arrearTotalETB = filteredArrearsData
    .filter(item => normalizeCurrency(item.payment_mode) === "birr")
    .reduce((sum, item) => sum + (item.outstanding || 0), 0);

  // Apply Currency Filter to get filtered amounts for display
  const getFilteredAmounts = () => {
    if (selectedCurrency === "usd") {
      return {
        revenueTotal: revenueTotalUSD,
        arrearTotal: arrearTotalUSD,
        currencySymbol: "$"
      };
    } else if (selectedCurrency === "birr") {
      return {
        revenueTotal: revenueTotalETB,
        arrearTotal: arrearTotalETB,
        currencySymbol: "ETB"
      };
    } else {
      return {
        revenueTotal: revenueTotalUSD + revenueTotalETB,
        arrearTotal: arrearTotalUSD + arrearTotalETB,
        currencySymbol: "$ + ETB"
      };
    }
  };

  const filteredAmounts = getFilteredAmounts();

  const revenueStats = {
    totalTransactions: filteredRevenueData.length,
    uniqueCompanies: new Set(filteredRevenueData.map(item => item.company_name)).size,
    totalRevenue: revenueTotalUSD + revenueTotalETB
  };

  const arrearStats = {
    totalCompanies: filteredArrearsData.length,
    criticalAccounts: filteredArrearsData.filter(item => (item.overdue_days || 0) >= 90).length,
    totalOverdue: filteredArrearsData.filter(item => (item.overdue_days || 0) > 0).length,
    totalArrears: arrearTotalUSD + arrearTotalETB
  };

  // Filter Data with Year Range and Month Range
  const applyFilters = useCallback(() => {
    // Filter Revenue
    let filteredRevenue = [...revenueData];
    let filteredArrears = [...arrearsData];
    
    if (searchTerm) {
      filteredRevenue = filteredRevenue.filter(item =>
        item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.transaction_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.park_name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      filteredArrears = filteredArrears.filter(item =>
        item.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.agreement_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.park_name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    if (selectedPark !== "all") {
      filteredRevenue = filteredRevenue.filter(item => item.park_name === selectedPark);
      filteredArrears = filteredArrears.filter(item => item.park_name === selectedPark);
    }
    
    // YEAR RANGE FILTER
    if (startYear !== "all" || endYear !== "all") {
      filteredRevenue = filteredRevenue.filter(item => {
        const itemYear = parseInt(item.year);
        let startYearNum = startYear !== "all" ? parseInt(startYear) : -Infinity;
        let endYearNum = endYear !== "all" ? parseInt(endYear) : Infinity;
        return itemYear >= startYearNum && itemYear <= endYearNum;
      });
      
      filteredArrears = filteredArrears.filter(item => {
        const itemYear = parseInt(item.year);
        let startYearNum = startYear !== "all" ? parseInt(startYear) : -Infinity;
        let endYearNum = endYear !== "all" ? parseInt(endYear) : Infinity;
        return itemYear >= startYearNum && itemYear <= endYearNum;
      });
    }
    
    // Month Range Filter
    if (startMonth !== "all" || endMonth !== "all") {
      filteredRevenue = filteredRevenue.filter(item => {
        const itemMonth = parseInt(item.month);
        let startMonthNum = startMonth !== "all" ? parseInt(startMonth) : 1;
        let endMonthNum = endMonth !== "all" ? parseInt(endMonth) : 12;
        return itemMonth >= startMonthNum && itemMonth <= endMonthNum;
      });
      
      filteredArrears = filteredArrears.filter(item => {
        const itemMonth = parseInt(item.month);
        let startMonthNum = startMonth !== "all" ? parseInt(startMonth) : 1;
        let endMonthNum = endMonth !== "all" ? parseInt(endMonth) : 12;
        return itemMonth >= startMonthNum && itemMonth <= endMonthNum;
      });
    }
    
    // Keep single month filter for backward compatibility
    if (selectedMonth !== "all" && startMonth === "all" && endMonth === "all") {
      filteredRevenue = filteredRevenue.filter(item => item.month === selectedMonth);
      filteredArrears = filteredArrears.filter(item => item.month === selectedMonth);
    }
    
    // Currency filter using normalizeCurrency helper
    if (selectedCurrency !== "all") {
      filteredRevenue = filteredRevenue.filter(item => 
        normalizeCurrency(item.payment_mode) === selectedCurrency
      );
      filteredArrears = filteredArrears.filter(item => 
        normalizeCurrency(item.payment_mode) === selectedCurrency
      );
    }
    
    setFilteredRevenueData(filteredRevenue);
    setFilteredArrearsData(filteredArrears);
    setPage(0);
  }, [revenueData, arrearsData, searchTerm, selectedPark, startYear, endYear, selectedMonth, startMonth, endMonth, selectedCurrency]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  // Reset Filters
  const resetFilters = () => {
    setSearchTerm("");
    setSelectedPark("all");
    setStartYear("all");
    setEndYear("all");
    setSelectedMonth("all");
    setStartMonth("all");
    setEndMonth("all");
    setSelectedCurrency("all");
  };

  // Export to CSV
  const handleExportCSV = () => {
    const headers = ['Type', 'ID', 'Company Name', 'Park Name', 'Payment Mode', 'Amount', 'Date', 'Status'];
    const revenueRows = filteredRevenueData.map(item => [
      'Revenue',
      item.transaction_id,
      item.company_name,
      item.park_name,
      item.payment_mode,
      item.formattedAmount,
      item.transaction_date_formatted,
      item.payment_status
    ]);
    
    const arrearRows = filteredArrearsData.map(item => [
      'Arrear',
      item.agreement_id,
      item.company_name,
      item.park_name,
      item.payment_mode,
      item.formattedOutstanding,
      item.due_date_formatted,
      item.status
    ]);
    
    const csvData = [...revenueRows, ...arrearRows];
    const csvContent = [headers, ...csvData].map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `financial_comparison_${format(new Date(), 'yyyyMMdd')}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Pagination Handlers
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Get Combined Table Data
  const getCombinedTableData = () => {
    const revenueItems = filteredRevenueData.map(item => ({
      type: 'revenue',
      id: item.transaction_id,
      company_name: item.company_name,
      park_name: item.park_name,
      payment_mode: item.payment_mode,
      amount: item.amount,
      formattedAmount: item.formattedAmount,
      date: item.transaction_date_formatted,
      status: item.payment_status,
      rawData: item
    }));
    
    const arrearItems = filteredArrearsData.map(item => ({
      type: 'arrear',
      id: item.agreement_id,
      company_name: item.company_name,
      park_name: item.park_name,
      payment_mode: item.payment_mode,
      amount: item.outstanding,
      formattedAmount: item.formattedOutstanding,
      date: item.due_date_formatted,
      status: item.status,
      rawData: item
    }));
    
    const combined = [...revenueItems, ...arrearItems];
    combined.sort((a, b) => b.amount - a.amount);
    
    const startIndex = page * rowsPerPage;
    return combined.slice(startIndex, startIndex + rowsPerPage);
  };

  const getTotalCombinedCount = () => {
    return filteredRevenueData.length + filteredArrearsData.length;
  };

  // Chart Data Preparation with Currency Filter
  const getComparisonChartData = (currency = null) => {
    const parkData = {};
    
    // Add revenue data with currency filter
    let revenueToProcess = filteredRevenueData;
    if (currency) {
      revenueToProcess = filteredRevenueData.filter(item => 
        normalizeCurrency(item.payment_mode) === currency
      );
    } else if (selectedCurrency !== "all") {
      revenueToProcess = filteredRevenueData.filter(item => 
        normalizeCurrency(item.payment_mode) === selectedCurrency
      );
    }
    
    revenueToProcess.forEach(item => {
      if (!parkData[item.park_name]) {
        parkData[item.park_name] = {
          revenueAmount: 0,
          arrearAmount: 0,
          netPosition: 0
        };
      }
      parkData[item.park_name].revenueAmount += item.amount || 0;
    });
    
    // Add arrears data with currency filter
    let arrearsToProcess = filteredArrearsData;
    if (currency) {
      arrearsToProcess = filteredArrearsData.filter(item => 
        normalizeCurrency(item.payment_mode) === currency
      );
    } else if (selectedCurrency !== "all") {
      arrearsToProcess = filteredArrearsData.filter(item => 
        normalizeCurrency(item.payment_mode) === selectedCurrency
      );
    }
    
    arrearsToProcess.forEach(item => {
      if (!parkData[item.park_name]) {
        parkData[item.park_name] = {
          revenueAmount: 0,
          arrearAmount: 0,
          netPosition: 0
        };
      }
      parkData[item.park_name].arrearAmount += item.outstanding || 0;
    });
    
    // Calculate net position
    Object.keys(parkData).forEach(park => {
      parkData[park].netPosition = parkData[park].revenueAmount - parkData[park].arrearAmount;
    });
    
    return parkData;
  };

  // Comparison Bar Chart Component (Revenue vs Arrears)
  const ComparisonBarChart = ({ data, title, currencySymbol }) => {
    const parks = Object.keys(data);
    const maxRevenue = Math.max(...parks.map(p => data[p].revenueAmount), 0);
    const maxArrears = Math.max(...parks.map(p => data[p].arrearAmount), 0);
    const maxValue = Math.max(maxRevenue, maxArrears);
    
    if (parks.length === 0) {
      return (
        <Box sx={{ p: 5, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">No data available for {title}</Typography>
        </Box>
      );
    }
    
    return (
      <Box sx={{ p: 2, overflowX: 'auto' }}>
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
          {title}
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 3, minHeight: 400, justifyContent: 'center', flexWrap: 'wrap' }}>
          {parks.map((park) => {
            const revenueHeight = maxValue > 0 ? (data[park].revenueAmount / maxValue) * 250 : 0;
            const arrearsHeight = maxValue > 0 ? (data[park].arrearAmount / maxValue) * 250 : 0;
            
            return (
              <Box key={park} sx={{ textAlign: 'center', minWidth: 140, cursor: 'pointer' }}>
                <Tooltip
                  title={
                    <Box sx={{ p: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        Revenue: {currencySymbol}{formatNumber(data[park].revenueAmount)}
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff' }}>
                        Arrears: {currencySymbol}{formatNumber(data[park].arrearAmount)}
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#fff', fontWeight: 'bold' }}>
                        Net Position: {data[park].netPosition >= 0 ? '+' : ''}{formatNumber(Math.abs(data[park].netPosition))} {data[park].netPosition >= 0 ? 'Surplus' : 'Deficit'}
                      </Typography>
                    </Box>
                  }
                  arrow
                  placement="top"
                >
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 90 }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.5, justifyContent: 'center' }}>
                      <Box sx={{ textAlign: 'center' }}>
                        <Box sx={{ 
                          height: revenueHeight, 
                          width: '35px',
                          bgcolor: '#2e7d32',
                          borderRadius: '3px 3px 0 0',
                          margin: '0 auto',
                          transition: 'all 0.3s ease',
                          '&:hover': { opacity: 0.8, transform: 'translateY(-5px)' }
                        }} />
                        <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontSize: '9px', color: '#2e7d32', fontWeight: 'bold' }}>
                          Rev
                        </Typography>
                        <Typography variant="caption" sx={{ display: 'block', fontSize: '8px' }}>
                          {formatNumber(data[park].revenueAmount)}
                        </Typography>
                      </Box>
                      <Box sx={{ textAlign: 'center' }}>
                        <Box sx={{ 
                          height: arrearsHeight, 
                          width: '35px',
                          bgcolor: '#d32f2f',
                          borderRadius: '3px 3px 0 0',
                          margin: '0 auto',
                          transition: 'all 0.3s ease',
                          '&:hover': { opacity: 0.8, transform: 'translateY(-5px)' }
                        }} />
                        <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontSize: '9px', color: '#d32f2f', fontWeight: 'bold' }}>
                          Arr
                        </Typography>
                        <Typography variant="caption" sx={{ display: 'block', fontSize: '8px' }}>
                          {formatNumber(data[park].arrearAmount)}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography variant="caption" sx={{ mt: 0.5, display: 'block', fontWeight: 'bold', fontSize: '9px' }}>
                      {park.length > 12 ? park.substring(0, 10) + '...' : park}
                    </Typography>
                    
                  </Box>
                </Tooltip>
              </Box>
            );
          })}
        </Box>
        
        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 4, borderTop: '1px solid #e0e0e0', pt: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 20, height: 20, bgcolor: '#2e7d32', borderRadius: 1 }} />
            <Typography variant="caption">Revenue Collected</Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ width: 20, height: 20, bgcolor: '#d32f2f', borderRadius: 1 }} />
            <Typography variant="caption">Outstanding Arrears</Typography>
          </Box>
        </Box>
        
        <Box sx={{ mt: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Typography variant="caption" color="textSecondary">Total Revenue</Typography>
              <Typography variant="body2" fontWeight="bold" color="#2e7d32">
                {currencySymbol}{formatNumber(Object.values(data).reduce((sum, d) => sum + d.revenueAmount, 0))}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="caption" color="textSecondary">Total Arrears</Typography>
              <Typography variant="body2" fontWeight="bold" color="#d32f2f">
                {currencySymbol}{formatNumber(Object.values(data).reduce((sum, d) => sum + d.arrearAmount, 0))}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="caption" color="textSecondary">Net Position</Typography>
              <Typography variant="body2" fontWeight="bold" color={Object.values(data).reduce((sum, d) => sum + (d.revenueAmount - d.arrearAmount), 0) >= 0 ? '#2e7d32' : '#d32f2f'}>
                {formatNumber(Math.abs(Object.values(data).reduce((sum, d) => sum + (d.revenueAmount - d.arrearAmount), 0)))} 
                {Object.values(data).reduce((sum, d) => sum + (d.revenueAmount - d.arrearAmount), 0) >= 0 ? ' Surplus' : ' Deficit'}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
  };

  // Net Position Line Chart
  const NetPositionChart = ({ data, title, currencySymbol }) => {
    const parks = Object.keys(data);
    const maxNet = Math.max(...parks.map(p => Math.abs(data[p].netPosition)), 1);
    
    if (parks.length === 0) {
      return (
        <Box sx={{ p: 5, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">No data available for {title}</Typography>
        </Box>
      );
    }
    
    const chartHeight = 350;
    const chartWidth = Math.max(800, parks.length * 80);
    const padding = { top: 30, right: 40, bottom: 80, left: 70 };
    
    return (
      <Box sx={{ p: 2, overflowX: 'auto' }}>
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', mb: 3, textAlign: 'center' }}>
          {title}
        </Typography>
        
        <svg width={chartWidth} height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} preserveAspectRatio="xMidYMid meet">
          {[-100, -75, -50, -25, 0, 25, 50, 75, 100].map((percent) => {
            const y = chartHeight - padding.bottom - ((percent + 100) / 200) * (chartHeight - padding.top - padding.bottom);
            const value = (maxNet * percent) / 100;
            return (
              <g key={percent}>
                <line x1={padding.left} y1={y} x2={chartWidth - padding.right} y2={y} stroke="#e0e0e0" strokeWidth="1" strokeDasharray="4" />
                <text x={padding.left - 8} y={y} textAnchor="end" fontSize="10" fill="#666">{formatNumber(value)}</text>
              </g>
            );
          })}
          
          <line x1={padding.left} y1={chartHeight - padding.bottom - (100 / 200) * (chartHeight - padding.top - padding.bottom)} x2={chartWidth - padding.right} y2={chartHeight - padding.bottom - (100 / 200) * (chartHeight - padding.top - padding.bottom)} stroke="#999" strokeWidth="2" strokeDasharray="8" />
          
          <polyline points={parks.map((park, index) => {
            const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
            const normalizedValue = ((data[park].netPosition + maxNet) / (maxNet * 2)) * 100;
            const y = chartHeight - padding.bottom - (normalizedValue / 100) * (chartHeight - padding.top - padding.bottom);
            return `${x},${y}`;
          }).join(' ')} fill="none" stroke="#1976d2" strokeWidth="2.5" />
          
          {parks.map((park, index) => {
            const x = padding.left + (index / (parks.length - 1 || 1)) * (chartWidth - padding.left - padding.right);
            const normalizedValue = ((data[park].netPosition + maxNet) / (maxNet * 2)) * 100;
            const y = chartHeight - padding.bottom - (normalizedValue / 100) * (chartHeight - padding.top - padding.bottom);
            const isPositive = data[park].netPosition >= 0;
            
            return (
              <g key={park}>
                <Tooltip title={<Box sx={{ p: 1 }}><Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#fff' }}>{park}</Typography><Typography variant="body2" sx={{ color: '#fff' }}>Revenue: {formatNumber(data[park].revenueAmount)}</Typography><Typography variant="body2" sx={{ color: '#fff' }}>Arrears: {formatNumber(data[park].arrearAmount)}</Typography><Typography variant="body2" sx={{ color: '#fff', fontWeight: 'bold' }}>Net Position: {isPositive ? '+' : ''}{formatNumber(data[park].netPosition)}</Typography></Box>} arrow placement="top">
                  <circle cx={x} cy={y} r="6" fill={isPositive ? '#2e7d32' : '#d32f2f'} stroke="white" strokeWidth="2" style={{ cursor: 'pointer' }} />
                </Tooltip>
                <text x={x} y={chartHeight - padding.bottom + 20} textAnchor="middle" fontSize="10" transform={`rotate(-45, ${x}, ${chartHeight - padding.bottom + 20})`}>
                  {park.length > 15 ? park.substring(0, 12) + '...' : park}
                </text>
              </g>
            );
          })}
          
          <line x1={padding.left} y1={padding.top} x2={padding.left} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1.5" />
          <line x1={padding.left} y1={chartHeight - padding.bottom} x2={chartWidth - padding.right} y2={chartHeight - padding.bottom} stroke="#999" strokeWidth="1.5" />
          <text x={25} y={chartHeight / 2} textAnchor="middle" fontSize="11" fill="#666" transform={`rotate(-90, 25, ${chartHeight / 2})`}>Net Position (Revenue - Arrears)</text>
        </svg>
        
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#2e7d32', borderRadius: '50%' }} /><Typography variant="caption">Positive Net Position (Surplus)</Typography></Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 12, height: 12, bgcolor: '#d32f2f', borderRadius: '50%' }} /><Typography variant="caption">Negative Net Position (Deficit)</Typography></Box>
        </Box>
      </Box>
    );
  };

  // Regular Bar Chart for Revenue or Arrears only
  const RegularBarChart = ({ title, data, totalAmount, currencySymbol, type }) => {
    const maxValue = Math.max(...Object.values(data).map(d => d.totalRevenue || d.totalArrears || 0), 0);
    const parks = Object.keys(data);
    
    if (parks.length === 0) {
      return (
        <Box sx={{ p: 5, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">No {title} data available</Typography>
        </Box>
      );
    }
    
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', color: '#1A237E', textAlign: 'center', mb: 3 }}>
          {title} - Total: {currencySymbol}{formatNumber(totalAmount)}
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, minHeight: 350, justifyContent: 'center', flexWrap: 'wrap' }}>
          {Object.entries(data).map(([park, parkData]) => {
            const value = parkData.totalRevenue || parkData.totalArrears || 0;
            const height = maxValue > 0 ? (value / maxValue) * 250 : 0;
            const color = type === 'revenue' ? '#2e7d32' : '#d32f2f';
            
            return (
              <Tooltip key={park} title={`${park}: ${currencySymbol}${formatNumber(value)}`} arrow placement="top">
                <Box sx={{ textAlign: 'center', flex: 1, minWidth: 80, cursor: 'pointer' }}>
                  <Box sx={{ height: height, width: '70px', bgcolor: color, borderRadius: '4px 4px 0 0', margin: '0 auto', transition: 'all 0.3s ease', '&:hover': { opacity: 0.8, transform: 'translateY(-5px)' } }} />
                  <Typography variant="caption" sx={{ mt: 1, display: 'block', fontWeight: 'bold' }}>
                    {park.length > 12 ? park.substring(0, 10) + '...' : park}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {currencySymbol}{formatNumber(value)}
                  </Typography>
                </Box>
              </Tooltip>
            );
          })}
        </Box>
        
        <Box sx={{ mt: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1, textAlign: 'center' }}>
          <Typography variant="body2" color="textSecondary">
            Number of Parks: {parks.length} | Total Amount: {currencySymbol}{formatNumber(totalAmount)}
          </Typography>
        </Box>
      </Box>
    );
  };

  // Get separate currency data for charts
  const getCurrencySpecificData = () => {
    const usdData = getComparisonChartData("usd");
    const birrData = getComparisonChartData("birr");
    
    const usdRevenueTotal = filteredRevenueData
      .filter(item => normalizeCurrency(item.payment_mode) === "usd")
      .reduce((sum, item) => sum + (item.amount || 0), 0);
    
    const birrRevenueTotal = filteredRevenueData
      .filter(item => normalizeCurrency(item.payment_mode) === "birr")
      .reduce((sum, item) => sum + (item.amount || 0), 0);
    
    const usdArrearTotal = filteredArrearsData
      .filter(item => normalizeCurrency(item.payment_mode) === "usd")
      .reduce((sum, item) => sum + (item.outstanding || 0), 0);
    
    const birrArrearTotal = filteredArrearsData
      .filter(item => normalizeCurrency(item.payment_mode) === "birr")
      .reduce((sum, item) => sum + (item.outstanding || 0), 0);
    
    return {
      usd: { data: usdData, revenueTotal: usdRevenueTotal, arrearTotal: usdArrearTotal },
      birr: { data: birrData, revenueTotal: birrRevenueTotal, arrearTotal: birrArrearTotal }
    };
  };

  // Render Chart based on currency selection and comparison type
  const renderChart = () => {
    if (selectedCurrency === "usd") {
      const usdData = getComparisonChartData("usd");
      const usdRevenueTotal = filteredRevenueData
        .filter(item => normalizeCurrency(item.payment_mode) === "usd")
        .reduce((sum, item) => sum + (item.amount || 0), 0);
      const usdArrearTotal = filteredArrearsData
        .filter(item => normalizeCurrency(item.payment_mode) === "usd")
        .reduce((sum, item) => sum + (item.outstanding || 0), 0);
      
      if (comparisonType === 'revenue') {
        const revenueChartData = {};
        Object.entries(usdData).forEach(([park, parkData]) => {
          revenueChartData[park] = { totalRevenue: parkData.revenueAmount };
        });
        return (
          <RegularBarChart 
            title={`Revenue Distribution by Park (USD)`}
            data={revenueChartData} 
            totalAmount={usdRevenueTotal}
            currencySymbol="$"
            type="revenue"
          />
        );
      } else if (comparisonType === 'arrears') {
        const arrearChartData = {};
        Object.entries(usdData).forEach(([park, parkData]) => {
          arrearChartData[park] = { totalArrears: parkData.arrearAmount };
        });
        return (
          <RegularBarChart 
            title={`Arrears Distribution by Park (USD)`}
            data={arrearChartData} 
            totalAmount={usdArrearTotal}
            currencySymbol="$"
            type="arrears"
          />
        );
      } else if (comparisonType === 'comparison' && chartType === 'bar') {
        return <ComparisonBarChart data={usdData} title="Revenue vs Arrears by Park (USD)" currencySymbol="$" />;
      } else {
        return <NetPositionChart data={usdData} title="Net Financial Position by Park (USD)" currencySymbol="$" />;
      }
    } 
    else if (selectedCurrency === "birr") {
      const birrData = getComparisonChartData("birr");
      const birrRevenueTotal = filteredRevenueData
        .filter(item => normalizeCurrency(item.payment_mode) === "birr")
        .reduce((sum, item) => sum + (item.amount || 0), 0);
      const birrArrearTotal = filteredArrearsData
        .filter(item => normalizeCurrency(item.payment_mode) === "birr")
        .reduce((sum, item) => sum + (item.outstanding || 0), 0);
      
      if (comparisonType === 'revenue') {
        const revenueChartData = {};
        Object.entries(birrData).forEach(([park, parkData]) => {
          revenueChartData[park] = { totalRevenue: parkData.revenueAmount };
        });
        return (
          <RegularBarChart 
            title={`Revenue Distribution by Park (ETB)`}
            data={revenueChartData} 
            totalAmount={birrRevenueTotal}
            currencySymbol="ETB"
            type="revenue"
          />
        );
      } else if (comparisonType === 'arrears') {
        const arrearChartData = {};
        Object.entries(birrData).forEach(([park, parkData]) => {
          arrearChartData[park] = { totalArrears: parkData.arrearAmount };
        });
        return (
          <RegularBarChart 
            title={`Arrears Distribution by Park (ETB)`}
            data={arrearChartData} 
            totalAmount={birrArrearTotal}
            currencySymbol="ETB"
            type="arrears"
          />
        );
      } else if (comparisonType === 'comparison' && chartType === 'bar') {
        return <ComparisonBarChart data={birrData} title="Revenue vs Arrears by Park (ETB)" currencySymbol="ETB" />;
      } else {
        return <NetPositionChart data={birrData} title="Net Financial Position by Park (ETB)" currencySymbol="ETB" />;
      }
    }
    else {
      // When "All" currencies is selected, show side by side charts
      const currencyData = getCurrencySpecificData();
      
      if (comparisonType === 'revenue') {
        const usdRevenueChartData = {};
        const birrRevenueChartData = {};
        
        Object.entries(currencyData.usd.data).forEach(([park, parkData]) => {
          usdRevenueChartData[park] = { totalRevenue: parkData.revenueAmount };
        });
        Object.entries(currencyData.birr.data).forEach(([park, parkData]) => {
          birrRevenueChartData[park] = { totalRevenue: parkData.revenueAmount };
        });
        
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
                <RegularBarChart 
                  title={`Revenue Distribution by Park (USD)`}
                  data={usdRevenueChartData} 
                  totalAmount={currencyData.usd.revenueTotal}
                  currencySymbol="$"
                  type="revenue"
                />
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
                <RegularBarChart 
                  title={`Revenue Distribution by Park (ETB)`}
                  data={birrRevenueChartData} 
                  totalAmount={currencyData.birr.revenueTotal}
                  currencySymbol="ETB"
                  type="revenue"
                />
              </Paper>
            </Grid>
          </Grid>
        );
      } 
      else if (comparisonType === 'arrears') {
        const usdArrearChartData = {};
        const birrArrearChartData = {};
        
        Object.entries(currencyData.usd.data).forEach(([park, parkData]) => {
          usdArrearChartData[park] = { totalArrears: parkData.arrearAmount };
        });
        Object.entries(currencyData.birr.data).forEach(([park, parkData]) => {
          birrArrearChartData[park] = { totalArrears: parkData.arrearAmount };
        });
        
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
                <RegularBarChart 
                  title={`Arrears Distribution by Park (USD)`}
                  data={usdArrearChartData} 
                  totalAmount={currencyData.usd.arrearTotal}
                  currencySymbol="$"
                  type="arrears"
                />
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
                <RegularBarChart 
                  title={`Arrears Distribution by Park (ETB)`}
                  data={birrArrearChartData} 
                  totalAmount={currencyData.birr.arrearTotal}
                  currencySymbol="ETB"
                  type="arrears"
                />
              </Paper>
            </Grid>
          </Grid>
        );
      }
      else if (comparisonType === 'comparison' && chartType === 'bar') {
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
                <ComparisonBarChart data={currencyData.usd.data} title="Revenue vs Arrears by Park (USD)" currencySymbol="$" />
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
                <ComparisonBarChart data={currencyData.birr.data} title="Revenue vs Arrears by Park (ETB)" currencySymbol="ETB" />
              </Paper>
            </Grid>
          </Grid>
        );
      }
      else {
        return (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
                <NetPositionChart data={currencyData.usd.data} title="Net Financial Position by Park (USD)" currencySymbol="$" />
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 1, borderRadius: 2, height: '100%' }}>
                <NetPositionChart data={currencyData.birr.data} title="Net Financial Position by Park (ETB)" currencySymbol="ETB" />
              </Paper>
            </Grid>
          </Grid>
        );
      }
    }
  };

  const loading = revenueLoading || arrearsLoading;

  // Handle chart type change
  const handleChartTypeChange = (event, newChartType) => {
    if (newChartType !== null) {
      setChartType(newChartType);
    }
  };

  return (
    <Box sx={{ width: '100%', bgcolor: '#f5f5f5', minHeight: '100vh', p: 3 }}>
      {/* Header Section */}
      <Typography variant="h5" gutterBottom sx={{ color: '#1a237e', fontWeight: 'bold', textAlign: 'center', mb: 1 }}>
        Financial Performance Dashboard
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', mb: 3 }}>
        Revenue Collection vs Outstanding Arrears Analysis
      </Typography>
      
      {/* Summary Cards - Using abbreviated format */}
      <Grid container spacing={1.5} sx={{ mb: 2 }}>
        {/* Total Revenue Card */}
        <Grid item xs={12} sm={4} md={3}>
          <Card sx={{ bgcolor: '#e8f5e9', boxShadow: 2 }}>
            <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
              <Box display="flex" alignItems="center" justifyContent="space-between" gap={0.5}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold', fontSize: '0.6rem', display: 'block' }}>Revenue</Typography>
                  <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 'bold', fontSize: '0.7rem', lineHeight: 1.2 }}>
                    {selectedCurrency === "usd" ? `$${formatNumberWithAbbreviation(revenueTotalUSD)}` : 
                     selectedCurrency === "birr" ? `${formatNumberWithAbbreviation(revenueTotalETB)} ETB` : 
                     `$${formatNumberWithAbbreviation(revenueTotalUSD)}`}
                    {selectedCurrency === "all" && ` / ${formatNumberWithAbbreviation(revenueTotalETB)} ETB`}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#999', fontSize: '0.55rem', display: 'block' }}>
                    {formatNumberWithAbbreviation(revenueStats.totalTransactions)} Txs | {formatNumberWithAbbreviation(revenueStats.uniqueCompanies)} Co.
                  </Typography>
                </Box>
                <TrendingUpIcon sx={{ fontSize: 24, color: '#2e7d32' }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        {/* Total Arrears Card */}
        <Grid item xs={12} sm={4} md={3}>
          <Card sx={{ bgcolor: '#ffebee', boxShadow: 2 }}>
            <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
              <Box display="flex" alignItems="center" justifyContent="space-between" gap={0.5}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold', fontSize: '0.6rem', display: 'block' }}>Arrears</Typography>
                  <Typography variant="body2" sx={{ color: '#d32f2f', fontWeight: 'bold', fontSize: '0.7rem', lineHeight: 1.2 }}>
                    {selectedCurrency === "usd" ? `$${formatNumberWithAbbreviation(arrearTotalUSD)}` : 
                     selectedCurrency === "birr" ? `${formatNumberWithAbbreviation(arrearTotalETB)} ETB` : 
                     `$${formatNumberWithAbbreviation(arrearTotalUSD)}`}
                    {selectedCurrency === "all" && ` / ${formatNumberWithAbbreviation(arrearTotalETB)} ETB`}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#999', fontSize: '0.55rem', display: 'block' }}>
                    {formatNumberWithAbbreviation(arrearStats.totalCompanies)} Accts | {formatNumberWithAbbreviation(arrearStats.criticalAccounts)} Critical
                  </Typography>
                </Box>
                <WarningIcon sx={{ fontSize: 24, color: '#d32f2f' }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        {/* Net USD Position Card */}
        <Grid item xs={12} sm={4} md={3}>
          <Card sx={{ bgcolor: revenueTotalUSD - arrearTotalUSD >= 0 ? '#e8f5e9' : '#ffebee', boxShadow: 2 }}>
            <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
              <Box display="flex" alignItems="center" justifyContent="space-between" gap={0.5}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold', fontSize: '0.6rem', display: 'block' }}>Net USD</Typography>
                  <Typography variant="body2" sx={{ color: revenueTotalUSD - arrearTotalUSD >= 0 ? '#2e7d32' : '#d32f2f', fontWeight: 'bold', fontSize: '0.7rem', lineHeight: 1.2 }}>
                    {revenueTotalUSD - arrearTotalUSD >= 0 ? '+' : ''}{formatNumberWithAbbreviation(Math.abs(revenueTotalUSD - arrearTotalUSD))}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#666', fontSize: '0.55rem', display: 'block' }}>
                    ${formatNumberWithAbbreviation(revenueTotalUSD)} - ${formatNumberWithAbbreviation(arrearTotalUSD)}
                  </Typography>
                </Box>
                <TrendingUpIcon sx={{ fontSize: 24, color: revenueTotalUSD - arrearTotalUSD >= 0 ? '#2e7d32' : '#d32f2f' }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        {/* Net ETB Position Card */}
        <Grid item xs={12} sm={4} md={3}>
          <Card sx={{ bgcolor: revenueTotalETB - arrearTotalETB >= 0 ? '#e8f5e9' : '#ffebee', boxShadow: 2 }}>
            <CardContent sx={{ py: 1, px: 1.5, '&:last-child': { pb: 1 } }}>
              <Box display="flex" alignItems="center" justifyContent="space-between" gap={0.5}>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold', fontSize: '0.6rem', display: 'block' }}>Net ETB</Typography>
                  <Typography variant="body2" sx={{ color: revenueTotalETB - arrearTotalETB >= 0 ? '#2e7d32' : '#d32f2f', fontWeight: 'bold', fontSize: '0.7rem', lineHeight: 1.2 }}>
                    {revenueTotalETB - arrearTotalETB >= 0 ? '+' : ''}{formatNumberWithAbbreviation(Math.abs(revenueTotalETB - arrearTotalETB))}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#666', fontSize: '0.55rem', display: 'block' }}>
                    {formatNumberWithAbbreviation(revenueTotalETB)} - {formatNumberWithAbbreviation(arrearTotalETB)} ETB
                  </Typography>
                </Box>
                <AccountBalanceIcon sx={{ fontSize: 24, color: revenueTotalETB - arrearTotalETB >= 0 ? '#2e7d32' : '#d32f2f' }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      
      {/* Filters Section */}
      <Paper elevation={2} sx={{ p: 2, mb: 3, borderRadius: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              size="small"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (<InputAdornment position="start"><SearchIcon /></InputAdornment>),
                endAdornment: searchTerm && (<InputAdornment position="end"><ClearIcon sx={{ cursor: 'pointer' }} onClick={() => setSearchTerm("")} /></InputAdornment>)
              }}
            />
          </Grid>
          
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Park</InputLabel>
              <Select value={selectedPark} onChange={(e) => setSelectedPark(e.target.value)} label="Park">
                <MenuItem value="all">All Parks</MenuItem>
                {parksList.map((park) => (<MenuItem key={park} value={park}>{park}</MenuItem>))}
              </Select>
            </FormControl>
          </Grid>
          
          {/* Year From Dropdown */}
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Year From</InputLabel>
              <Select value={startYear} onChange={(e) => setStartYear(e.target.value)} label="Year From">
                {years.map((year) => (<MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>))}
              </Select>
            </FormControl>
          </Grid>
          
          {/* Year To Dropdown */}
          <Grid item xs={12} md={1.5}>
            <FormControl fullWidth size="small">
              <InputLabel>Year To</InputLabel>
              <Select value={endYear} onChange={(e) => setEndYear(e.target.value)} label="Year To">
                {years.map((year) => (<MenuItem key={year} value={year}>{year === "all" ? "All Years" : year}</MenuItem>))}
              </Select>
            </FormControl>
          </Grid>
          
          {/* Month From */}
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Month From</InputLabel>
              <Select value={startMonth} onChange={(e) => setStartMonth(e.target.value)} label="Month From">
                {months.map((month) => (<MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>))}
              </Select>
            </FormControl>
          </Grid>
          
          {/* Month To */}
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Month To</InputLabel>
              <Select value={endMonth} onChange={(e) => setEndMonth(e.target.value)} label="Month To">
                {months.map((month) => (<MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>))}
              </Select>
            </FormControl>
          </Grid>

          {/* Currency Dropdown */}
          <Grid item xs={12} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Currency</InputLabel>
              <Select value={selectedCurrency} onChange={(e) => setSelectedCurrency(e.target.value)} label="Currency">
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="usd">USD</MenuItem>
                <MenuItem value="birr">Birr</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={2}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button fullWidth variant="outlined" onClick={resetFilters} startIcon={<ClearIcon />} size="small" sx={{ textTransform: 'none', borderColor: '#1976d2', color: '#1976d2', '&:hover': { borderColor: '#1565c0', backgroundColor: 'rgba(25, 118, 210, 0.04)' } }}>
                Reset
              </Button>
              <Button
                fullWidth
                variant="contained"
                color="inherit"
                size="small"
                onClick={handleExportCSV}
                startIcon={<DownloadIcon />}
                sx={{ textTransform: 'none' }}
              >
                Export
              </Button>
            </Box>
          </Grid>
        </Grid>
        
        {/* Chart Controls Row */}
        <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography variant="body2" color="textSecondary">View:</Typography>
              <ToggleButtonGroup value={comparisonType} exclusive onChange={(e, val) => val && setComparisonType(val)} size="small">
                <ToggleButton value="revenue"><Tooltip title="Revenue Only"><ReceiptIcon fontSize="small" /></Tooltip></ToggleButton>
                <ToggleButton value="arrears"><Tooltip title="Arrears Only"><WarningIcon fontSize="small" /></Tooltip></ToggleButton>
                <ToggleButton value="comparison"><Tooltip title="Revenue vs Arrears"><CompareIcon fontSize="small" /></Tooltip></ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Grid>
          
          {comparisonType === 'comparison' && (
            <Grid item xs={12} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Typography variant="body2" color="textSecondary">Chart Type:</Typography>
                <ToggleButtonGroup value={chartType} exclusive onChange={handleChartTypeChange} size="small">
                  <ToggleButton value="bar"><Tooltip title="Bar Chart"><BarChartIcon fontSize="small" /></Tooltip></ToggleButton>
                  <ToggleButton value="line"><Tooltip title="Line Chart"><ShowChartIcon fontSize="small" /></Tooltip></ToggleButton>
                </ToggleButtonGroup>

                <Button 
                variant="outlined" 
                size="small" 
                onClick={() => setShowChart(!showChart)} 
                sx={{ 
                  minWidth: '120px', 
                  textTransform: 'none',
                  borderColor: '#1976d2',
                  color: '#1976d2',
                  '&:hover': { 
                    borderColor: '#1976d2',
                    backgroundColor: '#f5f5f5',
                    color: '#1976d2'
                  } 
                }}
              >
                {showChart ? "Hide Chart" : "Show Chart"}
              </Button>
              </Box>
            </Grid>
          )}
          
          <Grid item xs={12} md={comparisonType === 'comparison' ? 6 : 9}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
             
            </Box>
          </Grid>
        </Grid>
      </Paper>
      
      {/* Conditional Rendering: Show Chart OR Table */}
      {showChart ? (
        <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mb: 3 }}>
          {!loading && renderChart()}
        </Paper>
      ) : (
        <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
          <Box sx={{ p: 2, bgcolor: '#fafafa', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Financial Records (Revenue & Arrears)</Typography>
            <Typography variant="body2" color="textSecondary">Showing {getTotalCombinedCount()} total records</Typography>
          </Box>
          
          <TableContainer>
            <Table size="small">
              <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>ID</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Company</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Park</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Currency</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 'bold' }}>Amount</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow><TableCell colSpan={8} align="center"><CircularProgress size={40} /><Typography sx={{ mt: 1 }}>Loading...</Typography></TableCell></TableRow>
                ) : getCombinedTableData().length === 0 ? (
                  <TableRow><TableCell colSpan={8} align="center"><Typography sx={{ py: 3 }}>No records found</Typography></TableCell></TableRow>
                ) : (
                  getCombinedTableData().map((item, index) => (
                    <TableRow key={`${item.type}-${item.id}-${index}`} hover>
                      <TableCell>{item.type === 'revenue' ? 'Revenue' : 'Arrear'}</TableCell>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{item.company_name}</TableCell>
                      <TableCell>{item.park_name}</TableCell>
                      <TableCell>{item.payment_mode}</TableCell>
                      <TableCell align="right" sx={{ color: item.type === 'revenue' ? '#2e7d32' : '#d32f2f', fontWeight: 'bold' }}>{item.formattedAmount}</TableCell>
                      <TableCell>{item.date}</TableCell>
                      <TableCell align="center">
                        <Tooltip title="View Details">
                          <IconButton size="small" color="primary" onClick={() => { setSelectedItem(item.rawData); setDetailsType(item.type); setOpenDetailsDialog(true); }}>
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          
          <TablePagination rowsPerPageOptions={[5, 10, 25, 50]} component="div" count={getTotalCombinedCount()} rowsPerPage={rowsPerPage} page={page} onPageChange={handleChangePage} onRowsPerPageChange={handleChangeRowsPerPage} />
        </Paper>
      )}
      
      {/* Details Dialog */}
      <Dialog open={openDetailsDialog} onClose={() => setOpenDetailsDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle><Box display="flex" justifyContent="space-between" alignItems="center"><Typography variant="h5" sx={{ fontWeight: 'bold' }}>{detailsType === 'revenue' ? 'Revenue Transaction Details' : 'Arrear Details'}</Typography><IconButton onClick={() => setOpenDetailsDialog(false)}><CloseIcon /></IconButton></Box></DialogTitle>
        <Divider />
        <DialogContent>
          {selectedItem && (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                {detailsType === 'revenue' ? (
                  <>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Transaction ID:</Typography><Typography variant="body2">{selectedItem.transaction_id}</Typography></Grid>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Company Name:</Typography><Typography variant="body2">{selectedItem.company_name}</Typography></Grid>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Park Name:</Typography><Typography variant="body2">{selectedItem.park_name}</Typography></Grid>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Payment Mode:</Typography><Typography variant="body2">{selectedItem.payment_mode}</Typography></Grid>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Amount:</Typography><Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 'bold' }}>{selectedItem.formattedAmount}</Typography></Grid>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Transaction Date:</Typography><Typography variant="body2">{selectedItem.transaction_date_formatted}</Typography></Grid>
                    <Grid item xs={12}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Description:</Typography><Typography variant="body2">{selectedItem.description}</Typography></Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Agreement ID:</Typography><Typography variant="body2">{selectedItem.agreement_id}</Typography></Grid>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Company Name:</Typography><Typography variant="body2">{selectedItem.company_name}</Typography></Grid>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Park Name:</Typography><Typography variant="body2">{selectedItem.park_name}</Typography></Grid>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Due Date:</Typography><Typography variant="body2">{selectedItem.due_date_formatted}</Typography></Grid>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Days Overdue:</Typography><Typography variant="body2">{selectedItem.overdue_days > 0 ? `${selectedItem.overdue_days} days` : 'Current'}</Typography></Grid>
                    <Grid item xs={12} md={6}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Status:</Typography><Chip label={selectedItem.status} size="small" color={selectedItem.statusColor} /></Grid>
                    <Grid item xs={12}><Typography variant="subtitle2" sx={{ color: '#1A237E' }}>Outstanding Balance:</Typography><Typography variant="body2" sx={{ color: '#d32f2f', fontWeight: 'bold' }}>{selectedItem.formattedOutstanding}</Typography></Grid>
                  </>
                )}
              </Grid>
            </Box>
          )}
        </DialogContent>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}><Button onClick={() => setOpenDetailsDialog(false)} variant="outlined">Close</Button></Box>
      </Dialog>
    </Box>
  );
}